var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _environmentCard, _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "Estado",
    "history": "Energía",
    "layout": "Conjunto de paneles",
    "menu": "Menú"
  },
  "button": {
    "cancel": "Cancelar",
    "done": "Hecho",
    "login": "Iniciar sesión",
    "today": "Hoy",
    "submit": "Enviar",
    "ok": "De acuerdo",
    "choose_file": "Escoger un archivo",
    "refresh": "Actualizar",
    "send": "Enviar",
    "skip": "Omitir",
    "clickHere": "Haga clic aquí",
    "confirm": "Confirmar",
    "reset": "Restablecer",
    "edit": "Editar",
    "update": "Actualizar",
    "next": "Siguiente",
    "save": "Guardar",
    "no": "No",
    "yes": "Sí",
    "enable": "Activar",
    "setNow": "Configurar ahora",
    "gotIt": "Entendido",
    "okGotIt": "Bien, entendido",
    "continue": "Continuar",
    "knowMore": "Saber más",
    "noExportCredit": "No tengo Crédito de exportación",
    "tryLater": "Inténtelo más tarde",
    "otherNetworks": "Otras redes"
  },
  "form": {
    "topic": "Tema",
    "contactSupport": {
      "success": {
        "message": "Gracias por contactarnos.",
        "description": "Nos complace ayudarlo a resolver su problema. Un experto de Enphase se comunicará con usted a la brevedad.",
        "email_notify": "En breve se enviará el informe a %{email}."
      },
      "error": {
        "message": "No se puede enviar el mensaje.",
        "description": "Por favor, intente nuevamente.",
        "reset_password": "La contraseña expiró. Podría reestablecer la contraseña."
      }
    },
    "default": {
      "success": "Guardado correctamente",
      "error": "Inténtelo de nuevo",
      "pleaseEnterAValue": "Por favor ingrese un valor",
      "permissionDenied": "Autorización denegada",
      "activeBatteryProfile": "Tiene una solicitud de perfil de batería activa. Espere la confirmación o cancele esa solicitud para continuar."
    },
    "search": "Buscar"
  },
  "common": {
    "please": "",
    "contactSupport": "Póngase en contacto con el Servicio de Soporte",
    "forHelp": "para obtener ayuda.",
    "videos": "Vídeos",
    "articles": "Artículos",
    "new": "Nuevo",
    "startDate": "Comienzo",
    "endDate": "Fecha final",
    "clearedDate": "Fecha autorizada",
    "startTime": "Hora de inicio",
    "endTime": "Hora de fin",
    "duration": "Duración"
  },
  "errors": {
    "error": "Error",
    "errors": "Errores",
    "retry": "Vuelve a intentarlo",
    "warning": "Warning",
    "email": "Introduzca su dirección de correo electrónico",
    "password": "Introduzca su contraseña",
    "login": "El correo electrónico y la contraseña que introdujo no coinciden con nuestros registros.",
    "accInactive": "La cuenta está inactiva. Póngase en contacto con su instalador e intente nuevamente una vez que su sistema esté completamente activo.",
    "expired": "Lo sentimos, el inicio de sesión ha caducado.",
    "loggedout": "Se ha cerrado la sesión.",
    "report": "Lo sentimos, se ha producido un error.",
    "offline": "Verifique su conexión a internet y vuelva a intentar.",
    "noInternet": "Sin internet",
    "message": "Mensaje",
    "tryagain": "Inténtelo de nuevo",
    "resetNow": "Reestablecer ahora",
    "resetPassword": "Su contraseña expiró. Reestablezca la contraseña para ver el informe",
    "validEmail": "Por favor ingrese una dirección de correo electrónico válida",
    "validPhone": "Ingrese un número telefónico válido",
    "fileError": "El logotipo de la empresa debe estar entre 0.05kb y 4MB.",
    "400": "Solicitud errónea",
    "401": "Acceso no autorizado",
    "403": "Acceso prohibido",
    "404": "Recurso no encontrado",
    "422": "Entidad no procesable",
    "500": "Error de servidor interno.",
    "502": "Pasarela de comunicaciones errónea.",
    "503": "Servicio no disponible.",
    "504": "Tiempo de espera de la pasarela de comunicaciones agotado.",
    "default": "Error de servidor.",
    "400_text": "Solicitud errónea",
    "401_text": "Acceso no autorizado",
    "403_text": "Acceso prohibido",
    "404_text": "Recurso no encontrado",
    "422_text": "Entidad no procesable",
    "500_text": "Error de servidor interno. Vuelva a intentarlo más tarde.",
    "502_text": "Pasarela de comunicaciones errónea. Vuelva a intentarlo más tarde.",
    "503_text": "Servicio no disponible. Vuelva a intentarlo más tarde.",
    "504_text": "Tiempo de espera de la pasarela de comunicaciones agotado. Vuelva a intentarlo más tarde.",
    "default_text": "Error de servidor. Vuelva a intentarlo más tarde.",
    "noDeviceFound": "Dispositivo no encontrado",
    "noBackupHistoryFound": "Historial de acumulación no encontrado",
    "noWiFiNetworkFound": "Redes Wi-Fi no detectadas",
    "noResultFound": "No se han encontrado resultados",
    "allSites": "Todos Los Sitios",
    "favorites": "Favoritos",
    "changesNotSaved": "Los cambios no se guardan",
    "wantToExit": "Quieres salir sin guardar?",
    "rateNotFound": "Tarifa no encontrada"
  },
  "login": {
    "forgot": "¿Olvidó la contraseña?",
    "signup": "Cuenta nueva",
    "header": "Inicie sesión en Enphase",
    "intro_content": "Entre su email registrado con Enphase.  Recibirá un email con vínculo para crear una nueva contraseña.",
    "remember_me": "Recordarme",
    "forgot_password": "¿Ha olvidado su contraseña?",
    "forgot_password_success": "Si ya se ha registrado en Enphase, compruebe su correo electrónico para ver las instrucciones de restablecimiento.",
    "caps_lock_warning": "Bloq Mayús está activada",
    "welcome_back": "Bienvenido de nuevo, %{user_name}. ",
    "en_us_installer_html": "Le damos la bienvenida %{user_name}. Visite nuestra sección de <a href='http://go.enphase.com/gettingstarted' target='_blank'>primeros pasos</a> y obtenga información de todo lo que necesita saber sobre el diseño, la instalación y la puesta en marcha de los sistemas Enphase. ",
    "en_aunz_installer_html": "Le damos la bienvenida %{user_name}. Visite nuestra sección de <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>primeros pasos</a> y obtenga información de todo lo que necesita saber sobre el diseño, la instalación y la puesta en marcha de los sistemas Enphase. ",
    "provide_email_password": "Proporcione un nombre de usuario y una contraseña.",
    "request_account": "Solicite una cuenta",
    "subheader": {
      "new_user": "¿Es nuevo en Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Los productos de Enphase Energy mejoran considerablemente el rendimiento de los sistemas de energía solar. Al usar microinversores Enphase, tanto los propietarios como los operarios aumentan la productividad y fiabilidad de su instalación solar.<br/><br/>Para ver Enphase en acción, <a href='%{systems_list_link}'>eche un vistazo a las instalaciones de nuestros clientes.</a>",
    "public_system_content_html": "¿Desea ver Enphase en acción? <a href='%{systems_list_link}'>Ver sistemas públicos</a>",
    "register_new_user_html": "¿Está instalando su primer sistema Enphase? <a href='%{register_user_link}'>Regístrese en Enphase</a>",
    "recommended_browsers": "La aplicación de Enphase es compatible con los siguientes navegadores: Chrome 5 o superior, Firefox 3.6 o superior, Internet Explorer 10 o superior, Microsoft Edge para Windows, Safari 4 o superior. La aplicación de Enphase requiere Adobe Flash Player 10.",
    "recommended_browsers_3x": "La aplicación de Enphase es compatible con los siguientes navegadores: Chrome 44 o superior, Firefox 41 o superior, Internet Explorer 11, Microsoft Edge para Windows, Safari 8 o superior.",
    "cookies_required": "Las cookies deben estar habilitadas.",
    "no_community": "Esta comunidad se dedica a los debates técnicos entre los instaladores de Enphase. Le damos la bienvenida a la participación en los debates en nuestra <a href='https://www.facebook.com/EnphaseEnergy'>página de Facebook</a>.",
    "required": "Debe iniciar sesión para acceder a esa página",
    "findInstaller": "Encontrar un instalador",
    "sizeYourSystem": "Dimensione su sistema",
    "getEnphase": "Obtener Enphase",
    "experienceTheApp": "Viva la experiencia de la aplicación",
    "viewStorageSystem": "Ver video",
    "meetEnphase": "Conoce a Enphase",
    "enphaseSolar": "Enphase Solar",
    "enphaseStorage": "Enphase Almacenamiento"
  },
  "logout": {
    "confirm_logout": "Ha cerrado sesión. Gracias por su visita."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Activar cuenta",
      "link": "Active su cuenta ahora."
    },
    "header": "Restablecimiento de contraseña",
    "intro_content": "Para solicitar un restablecimiento de contraseña, introduzca si dirección de email en la casilla que figura a continuación y haga clic en Enviar. Recibirá un email con instrucciones sobre cómo restablecer su contraseña.",
    "login": "Iniciar sesión",
    "try_again": "Vuelva a intentarlo.",
    "sent_message_html": "Si ya se ha registrado en Enlighten, compruebe su email para recibir instrucciones de restablecimiento. <span style='color:red'>Si no recibió el correo electrónico, compruebe su carpeta de correo no deseado/basura.</span>",
    "invalid_request": "Solicitud no válida",
    "invalid_link": "No se puede restablecer la contraseña. El vínculo de restablecimiento de contraseña es válido durante 7 días. Vuelva a intentarlo.",
    "success": "Contraseña restablecida correctamente.",
    "failed_password_reset": "Se ha detectado un problema. Vuelva a intentarlo.",
    "password_requirements": "Su contraseña debe contar con una extensión mínima de seis caracteres; además, debe contener al menos un número o carácter especial y no puede ser la misma que su dirección de email.",
    "note": "Contraseña ",
    "OK": "De acuerdo",
    "sent_email": "Hemos enviado un email a",
    "rest_pwd": "Toque el vínculo en el email para crear una nueva contraseña."
  },
  "users": {
    "new": "Nuevo registro de usuario",
    "company_details": "Detalles de la empresa",
    "edit": "Editar usuario",
    "site_accesses": "Acceso al sistema",
    "login": "Iniciar sesión",
    "logged_in_as": "%{admin}, ha iniciado sesión como %{user}",
    "logout_as": "Detener",
    "reset_password": "Restablecer contraseña",
    "preview_marketing_description": "Solo vista previa. Los cambios aún no se han guardado.",
    "preview_custom_welcome_message": "Solo vista previa. Los cambios aún no se han guardado.",
    "reset_password_confirm_html": "<b>¿Está seguro de que desea restablecer la contraseña para este usuario?</b><p>Esto hará que se establezca el usuario como activo, que se genere una nueva contraseña y que se le envíe un email de bienvenida al usuario.</p>",
    "reset_password_success": "Contraseña correctamente restablecida. Se enviará un email de bienvenida a %{email} con explicaciones acerca de cómo iniciar sesión.",
    "reset_password_failed": "Error al restablecer la contraseña.",
    "enlighten_manager_access": "Este usuario dispone de Enlighten Manager con acceso a datos de los módulos.",
    "myenlighten_access_note": "(solo para usuarios que NO estén asociados a una empresa)",
    "module_level_access_note": "(con acceso a datos de los módulos)",
    "complimentary_note": "NOTA: El cambio de usuario de MyEnlighten a Enlighten Manager supone regalar una activación de software valorada en %{price}. Esta transacción se registrará y se reportar de ella al departamento de finanzas.",
    "purchase_note": "%{email} adquirió la activación de software por %{price} el %{date}.",
    "enlighten_version_title": "Versión de la aplicación de Enphase",
    "unlock_account": "Desbloquear cuenta",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "Instalo yo mismo productos de Enphase en mi propia casa o negocio.",
    "self_installer_false": "Soy un profesional de los sistemas solares registrándome en nombre de mi empresa.",
    "self_register_independent": "Otro",
    "opt_in": "Acepto recibir boletines, promociones y encuestas relacionadas con los productos o servicios de Enphase.",
    "opt_in_info": "Puede retirar su consentimiento en cualquier momento. Para obtener más información, consulte la <a href='%{privacy_url}' target='_blank'>Política de privacidad</a> de Enphase o <a href='%{contact_url}' target='_blank'>póngase en contacto con nosotros</a>.",
    "personal_details": "Detalles personales",
    "enable_camera": "Habilite el acceso a la cámara para su aplicación desde la pestaña de configuración",
    "dont_allow": "No permitir",
    "cameraText": "Esto le permitirá seleccionar la imagen que desea cargar como logotipo de su empresa."
  },
  "forecast": {
    "nodata": "Los datos previstos no están disponibles.",
    "nodata5": "Requerimos al menos 5 días de datos de producción para predecir con exactitud los datos de producción.",
    "nodata10": "Necesitamos al menos 5 días de datos de producción en los últimos 15 días para mostrar su pronóstico.",
    "apifail": "¡No se pueden mostrar los datos previstos!",
    "apifailSub": "Error en la visualización de los datos de pronóstico debido a problemas técnicos. Compruebe después de algún tiempo.",
    "weatherErr": "Error en la visualización de los datos de pronóstico debido a la falta de disponibilidad de datos meteorológicos..",
    "weatherProdErr": "Error al mostrar los datos pronosticados debido a la falta de disponibilidad de datos meteorológicos o de producción.",
    "genErr": "Error en la visualización de los datos de pronóstico debido a problemas técnicos.",
    "envoyErr1": "Los datos de producción no están disponibles porque su puerta de enlace no informa a la nube.",
    "envoyErr2": "Los datos de producción no se están actualizando porque su puerta de enlace no está informando a la nube.",
    "microErr1": "Los datos de producción no están disponibles porque ninguno de los microinversores está informando",
    "microErr2": "Los datos de producción no se actualizan porque ninguno de los microinversores está informando",
    "accCTA": "¿Por qué su producción real es diferente de la previsión?",
    "ctainfo": "El pronóstico es solo una predicción para ayudarle a planificar sus necesidades de energía. Tenga en cuenta que sus valores de producción pueden ser diferentes de la previsión.",
    "ctainfoRes": "Posibles razones de las diferencias entre la producción real y la previsión",
    "ctainfoRes1": "Cambios meteorológicos frecuentes en su localidad",
    "ctainfoRes2": "Algunos de sus microinversores no están informando",
    "ctainfoRes3": "Su sistema no ha informado durante más de un día",
    "today": "Hoy",
    "forecast": "Pronóstico",
    "actual": "Actual",
    "timeFrom": "Mostrando las 12:00 del mediodía",
    "actualProd": "Actual Production",
    "sunrise": "Amanecer",
    "sunset": "Atardecer",
    "clearDay": "Mayormente soleado",
    "clearNight": "Mostly clear",
    "rain": "Mayormente lluvioso",
    "snow": "Mayormente con nieve",
    "sleet": "Mayormente con aguanieve",
    "wind": "Mayormente ventoso",
    "fog": "Mayormente nublado",
    "cloudy": "Nublado",
    "partlycloudy": "Parcialmente nublado",
    "unknown": "Unknown",
    "at12": "A las 12:00 del mediodía",
    "title": "Conozca su previsión de producción",
    "infoIconPopup": "La previsión de producción es la predicción de la cantidad de energía que producirán sus paneles hoy y en los próximos 5 días. La previsión se calcula en base a su producción energética pasada y a la previsión meteorológica de su región.",
    "fiveday": "Previsión de 5 días",
    "tomo": "Mañana"
  },
  "user": {
    "id": "ID de usuario",
    "api_key": "Clave API",
    "company": "Empresa",
    "company_id": "ID de la empresa",
    "consumer": "MyEnlighten",
    "country": "País",
    "email": "Dirección de correo electrónico",
    "email_confirm": "Confirmar email",
    "password": "Contraseña",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "sfdc_email": "Correo electrónico",
    "sfdc_subject": "Sujeto",
    "sfdc_message": "Mensaje",
    "sfdc_siteId": "ID del sitio de Enphase",
    "created_at": "Fecha de creación",
    "name": "Nombre",
    "updated_at": "Actualizado en",
    "status": "Estado",
    "phone": "Teléfono",
    "locale": "Lugar preferido",
    "preferred_metric": "Unidades",
    "preferred_alert_level": "Nivel de alerta predeterminado",
    "preferred_array_builder": "Puede crear conjuntos de paneles",
    "preferred_show_dashboard_help": "Preferencia de ayuda del panel",
    "preferred_new_look": "Vista previa de Enlighten 3.0",
    "preferences": "Preferencias",
    "role": "Rol",
    "roles_mask": "Máscara de roles",
    "sales_demo": "Demostración de ventas",
    "sees_modules": "Puede ver datos de los módulos",
    "notes": "Notas",
    "prefers_monthly_email": "Suscribirse a emails mensuales",
    "preferred_enphase_email": "Suscribirse a emails de Enphase",
    "prefers_privacy_policy_assent": "Términos de la Política de privacidad aceptados",
    "active": "Activo",
    "inactive": "Inactivo",
    "add_user": "Añadir usuario",
    "self_installer": "Autoinstalador",
    "site_access_id": "Número de Instalación",
    "user_access_id": "ID de usuario",
    "with_company": "Incluir detalles de la empresa en el registro",
    "last_login": "Último inicio de sesión",
    "acknowledge": "Reconozco que he leído y acepto Enphase",
    "privacy_url": "Política de privacidad",
    "terms_url": "Condiciones de servicio",
    "acknowledgementHead": "He leído los",
    "acknowledgementBody": "de Enphase y he leído y estoy de acuerdo con la"
  },
  "company": {
    "id": "ID de la empresa",
    "active_users": "Usuarios activos",
    "address1": "Dirección postal",
    "optional": "Opcional",
    "address2": "Dirección postal 2",
    "address_id": "Ubicación",
    "branch_name": "Nombre de la sucursal",
    "branch_of": "Sucursal de",
    "city": "Ciudad",
    "companies": "Sucursales",
    "country": "País",
    "duplicate_of": "Sustituido con",
    "latitude": "Latitud",
    "logo_img": "Logotipo de la empresa",
    "file_type_size": "Debe ser un archivo JPEG o PNG que no supere los 4 MB.",
    "file_recommendation": "Para obtener los mejores resultados, recomendamos una imagen cuadrada con un fondo transparente de al menos 400 px de ancho por 400 px de alto.",
    "logo_img_file_size": "Logotipo de la empresa",
    "logo_img_content_type": "Logotipo de la empresa",
    "longitude": "Longitud",
    "long_name": "Nombre de la empresa",
    "marketing_description": "Descripción de la empresa",
    "custom_welcome_message": "Email de bienvenida al cliente",
    "show_logo_in_welcome_email": "Mostrar logotipo de la empresa en el email de bienvenida",
    "name": "Nombre",
    "parent": "Empresa matriz",
    "phone": "Teléfono",
    "role": "Rol",
    "roles": {
      "admin": "Centro de llamadas/Soporte técnico",
      "installer": "Instalador",
      "distributor": "Distribuidor",
      "third_party_owner": "Tercer propietario"
    },
    "state": "Estado/Provincia",
    "support_email": "Email del soporte técnico del cliente",
    "support_phone": "Teléfono del soporte técnico del cliente",
    "timezone": "Zona horaria",
    "url": "URL del sitio web",
    "zip": "Código postal/ZIP",
    "is_installer": "Esta empresa instala sistemas Enphase",
    "errors": {
      "name_not_found": "No se ha podido encontrar el nombre de la empresa."
    },
    "success": {
      "msg": "Tu cuenta ha sido creada. Por favor, consulte su correo electrónico para obtener instrucciones sobre cómo iniciar sesión."
    }
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Nuestra política de privacidad se ha cambiado con fecha de efectividad del %{policy_date}",
      "link_body": "<a href='%{privacy_url}' target='_blank'>Ver política de privacidad</a>",
      "acknowledgement": "Confirmo que he leído y acepto la <a href='%{privacy_url}' target='_blank'>política de privacidad</a> de Enphase.",
      "continue_button": "Continuar",
      "privacy_settings_button": "Continuar a la configuración de privacidad",
      "privacy_policy_agreement_required": "Confirmo que he leído y acepto la <a target='_blank' href='%{privacy_url}'>Política de privacidad</a>\ny las <a target='_blank' href='%{terms_url}'>Condiciones de servicio</a> de Enphase.    \n"
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "Este campo es obligatorio."
    }
  },
  "validate": {
    "privacy_policy_accept": "Si no está de acuerdo con los términos de la Política de privacidad y los Términos de Servicio de Enphase, no puede registrarse en la aplicación de Enphase."
  },
  "period": {
    "hours": "Día",
    "days": "Mes",
    "week": "Semana",
    "months": "Año",
    "years": "Vida útil",
    "custom": "Personalizado"
  },
  "history": {
    "totals": "Valores totales",
    "graph": "Inicio",
    "production": "Generada",
    "consumption": "Consumida",
    "grid": "Proveedor",
    "export": "Exportada",
    "import": "Importada",
    "netExported": "Neta Exportada",
    "netImported": "Neta Importada",
    "battery": "Batería",
    "charge": "Cargada",
    "discharge": "Descargada",
    "soc": "Batería",
    "hours": "",
    "months": "",
    "today": "Hoy",
    "battery_status": "Cargar",
    "bulbs": "Bombilla de 100 w",
    "last_updated": "Actualizado",
    "power": "Potencia",
    "solar_produced": "Producida solar",
    "solar_consumed": "Energía solar consumida",
    "saved": "Salvado",
    "emission_saved": "Emisión de CO2 ahorrada",
    "refrigerator": "Refrigerador",
    "produced_today": "Producido hoy",
    "produced_yesterday": "Producido ayer",
    "this_week": "Esta semana",
    "last_week": "La semana pasada",
    "this_month": "Este mes",
    "last_month": "El mes pasado",
    "this_year": "Este año",
    "last_year": "El año pasado",
    "selected_day": "Día Seleccionado",
    "previous_day": "Día Anterior",
    "selected_week": "Semana Seleccionad",
    "previous_week": "Semana Anterior",
    "selected_month": "Mes Seleccionado",
    "previous_month": "Mes Anterior",
    "selected_year": "Año Seleccionado",
    "previous_year": "Año Anterior",
    "produced_this_week": "Producido esta semana",
    "produced_last_week": "Producido la semana pasada",
    "produced_this_year": "Producido este año",
    "produced_last_year": "Producido el año pasado",
    "produced_this_month": "Producido este mes",
    "produced_last_month": "Producido el mes pasado",
    "produced_lifetime": "Producido de por vida",
    "imported-exported": "Importada/Exportada",
    "yesterday": {
      "hours": "Ayer",
      "days": "Último mes",
      "months": "Último año",
      "years": "Generada"
    },
    "lastyear": {
      "hours": "Último año",
      "days": "Último año",
      "months": "Último año",
      "years": "Generada"
    },
    "generator": "Générateur"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Elegir la frecuencia de los datos",
      "daily": "Diariamente",
      "weekly": "Semanal",
      "monthly": "Mensualmente",
      "yearly": "Anualmente",
      "generateReport": "Necesitamos al menos una semana de datos para generar el informe"
    }
  },
  "calendar": {
    "select": "Seleccionar una fecha",
    "scale": {
      "production": "Producción",
      "consumption": "Consumo"
    },
    "weekDays": {
      "monday": "lunes",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "viernes",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "Enero",
      "february": "Febrero",
      "march": "Marzo",
      "april": "Abril",
      "may": "Mayo",
      "june": "Junio",
      "july": "Julio",
      "august": "Agosto",
      "september": "Septiembre",
      "october": "Octubre",
      "november": "Noviembre",
      "december": "Diciembre",
      "jan": "enero",
      "feb": "feb.",
      "mar": "marzo",
      "apr": "abr.",
      "jun": "jun.",
      "jul": "jul.",
      "aug": "agosto",
      "sep": "sept.",
      "oct": "oct.",
      "nov": "nov.",
      "dec": "dic."
    },
    "time": {
      "hour": "hora",
      "hours": "horas",
      "minute": "minuto",
      "minutes": "minutos",
      "second": "segundo",
      "seconds": "segundos",
      "millisecond": "milisegundo",
      "milliseconds": "milisegundos",
      "day": "día",
      "h": "h",
      "min": "min"
    }
  },
  "status": {
    "nameChangeNormal": "Normal",
    "nameChangeError": 'Error',
    "nameChangeWarning": 'Advertencia',
    "latest_solar_power": "Latest Solar Power",
    "dayTitle": "Estado de hoy",
    "dayAltTitle": "Último estado",
    "monthTitle": "Estado de este mes",
    "monthAltTitle": "Último estado mensual",
    "yearTitle": "Estado de este año",
    "yearAltTitle": "Último estado anual",
    "lifetimeTitle": "Estado de la vida útil",
    "lifetime": "Vida útil",
    "system_normal": "Sistema normal",
    "system_error": "Error del sistema",
    "energyConsumed": "Energía Consumida",
    "energyProduced": "Energía Producida",
    "powerProduced": "Poder Producido",
    "powerConsumed": "Poder Consumido",
    "moreDetails": "Más Detalles",
    "latest_power": "Última lectura",
    "latest_power_text": "La última energía solar es la última potencia de salida informada desde su sistema PV",
    "peak_power": "Potencia pico",
    "peak_power_text": "El punto máximo de potencia es la potencia de salida máxima de su sistema PV durante el período de tiempo seleccionado",
    "addEnphaseStorage": "Agregar batería de Enphase",
    "getAQuote": "Consigue una cotización",
    "production": {
      "title": "Solar",
      "label": "Generada",
      "section": "Destinos de la energía"
    },
    "consumption": {
      "title": "Uso",
      "label": "Consumida",
      "section": "Fuentes de energía"
    },
    "grid": {
      "title": "Energía neta",
      "export": "Exportada",
      "import": "Importada",
      "label": "Energía neta con importaciones/exportaciones",
      "section": "Fuentes de energía",
      "progressbarTitle": "Energía neta de la red"
    },
    "breakdown": {
      "consumption": "Inicio",
      "battery": "Almacenamiento",
      "production": "Solar",
      "grid": "Proveedor",
      "export": "Exportada",
      "import": "Importada",
      "soc": "Almacenado",
      "total": "Total",
      "peak": "Potencia máxima",
      "latest": "Última energía",
      "next": "Siguiente reporte"
    },
    "battery": {
      "title": "Almacenamiento",
      "label": {
        "none": "Inactividad",
        "positive": "Carga",
        "negative": "Descarga"
      },
      "section": "Energía disponible"
    },
    "charge": "Carga",
    "stormAlertOn": "Alerta de Tormenta: activado",
    "batteryProfile": "perfil de batería",
    "batteryInfo1": "Basado en el consumo de las últimas 24 horas (%{consumption}) su sistema Enphase funcionará aproximadamente ",
    "batteryInfo2": " sin red ni energía solar.",
    "batteryInfoWOSolar": " sin red.",
    "batteryErrorInfo": "No hay datos suficientes para calcular el tiempo de respaldo de batería.",
    "to": "hasta",
    "batteryZeroErrorInfo": "Tiene cero horas de respaldo ya que sus baterías están descargadas.",
    "hours": "hora(s)",
    "minutes": "minuto(s)",
    "gridControls": {
      "verifyOtp": "Verificar código",
      "verificationCode": "Código de verificación",
      "offGridContent": "Perderá la conexión a la Red. La potencia disponible para consumo estará restringida.",
      "tryAgainContent": "No se ha podido establecer una conexión con la Gateway.",
      "verifyOtpEmail": "Ingrese el código de 4 dígitos que se envió a su dirección de correo electrónico registrada.",
      "verifyOtpEmailMobile": "Ingrese el código de 4 dígitos que se envió a su dirección de correo electrónico registrada y al número de celular.",
      "verifyOtpUpdateMobile": "El código de 4 dígitos se enviará a su dirección de correo electrónico registrada.",
      "onGridContent": "¿Quiere volver a conectar su sistema a la Red ahora?",
      "pleaseTryAgain": "Inténtelo de nuevo",
      "enterValidOtp": "Introduzca un código válido",
      "didntReceiveOtp": "¿No recibió el código?",
      "goOffGrid": "Salir de la red",
      "goOnGrid": "Entrar a la red",
      "tryAgain": "intentar de nuevo",
      "resend": "Reenviar",
      "alert": "El acceso al control de red está deshabilitado porque hay una actualización en curso para su sistema. Esta actualización puede tardar hasta 24 horas. Espere a que se complete la actualización.",
      "sendCode": "Enviar código",
      "mobileStatus": "para recibir el código como texto.",
      "myInfoButton": "Actualice su número de celular",
      "wpc1l1": "Sus niveles de consumo actuales son superiores a la producción de energía solar disponible.  Reduzca su consumo para evitar que el sistema se apague durante la transición.",
      "wpc1l2": "Puede ver su producción solar actual y el consumo de las cargas esenciales en %{liveStatus}.",
      "wpc2l1": "El consumo medio de los últimos 15 minutos es mayor que la producción media de energía solar. Asegúrese de que su producción solar actual sea suficiente para soportar sus demandas de consumo para evitar el apagado del sistema cuando esté fuera de la red.",
      "wpcOnGrid": "Su sistema está actualmente alimentado por el generador. El cambio a En Red puede provocar una interrupción temporal del suministro eléctrico si su consumo es muy elevado. Reduzca su consumo para evitar esta interrupción.",
      "wpcOnGrid2": "Puede ver su consumo actual en %{liveStatus}."
    },
    "viewDetails": "Ver detalles",
    "socMessageError1": "El ",
    "socMessageError2": " de almacenamiento agregado excluye los porcentajes de almacenamiento de ",
    "socMessageError3": " Batería(s)",
    "socMessageThreshold": "La carga de la batería es desconocida debido a que ninguna de las baterías reportó datos durante el último ciclo de informes"
  },
  "menu": {
    "supportHistory": "Historial de soporte",
    "supportHistorySearch": "",
    "connectedAppliances": "Dispositivos conectados",
    "connectedAppliancesSubtitle": "Monitorea y controla tus dispositivos inteligentes",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Supervisa y controla tus electrodomésticos con Home Connect",
    "appTutorial1": "Puedes consultar todos los tutoriales sobre el sistema en cualquier momento navegando hasta Conozca su sistema en Sistema",
    "appTutorial2": "Conozca su sistema",
    "appTutorial": "Conozca su sistema",
    "AppTurorial3": "en",
    "AppTurorial4": "Sistema",
    "viewallsystutorial": "Ver todos los tutoriales del sistema",
    "voiceAssistant": "Asistente de voz",
    "voiceAssistantSubtitle": "Habilitar el control de voz para Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Previsión de producción",
    "dryContactLoads": "Cargas",
    "generator": "Générateur",
    "generatorDevice": "Générateur",
    "loadControl": "Control de carga",
    "loadControlSubtitle": "Controle la potencia de sus cargas",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Avisos",
    "newNotices": "Avisos",
    "reports": "Informes",
    "exploreEnphase": "Explorar Enphase",
    "exploreEnphaseNewMenu": "Explorar",
    "advanceSettings": "Ajustes avanzados",
    "advanceBatterySettings": "Ajustes avanzados",
    "advancedBatterySettings2": "Ajustes Avanzados",
    "details": "Detalles",
    "detailSite": "DETALLES DEL SITIO",
    "detailsInstaller": "DETALLES DEL INSTALADOR",
    "systemDescription": "Sistema Descripción",
    "systemStatistics": "Estadísticas del sistema",
    "settings": "Configuraciones",
    "account": "Cuenta",
    "support": "Soporte técnico",
    "supportFaq": "FAQs",
    "emergencySupport": "Llámanos ahora",
    "contactUs": "Contáctenos",
    "contactSupport": "Escríbenos",
    "devices": "Dispositivos",
    "addStorage": "Agregar almacenamiento",
    "devicesOld": "Dispositivos",
    "configure": "Configurar",
    "batteryStorage": "Almacenamiento de la batería",
    "batteryStorageNewMenu": "Batería",
    "connectivity": "Conectividad",
    "connectGateway": "Conectividad",
    "batteryReserve": "Reserva de batería",
    "expertModeEdit": "Modo experto",
    "eventsHistory": "Historial de eventos",
    "backupHistory": "Historial de respaldo",
    "outageHistory": "Historia de apagones",
    "event": "Evento",
    "events": "Eventos",
    "totalEvents": "Eventos totales",
    "totalBackup": "Respaldo de Batería",
    "backupDuration": "Duración de respaldo",
    "hours": "horas",
    "minutes": "minutos",
    "siteDetails": "Detalles del sitio",
    "envoy": "Gateway",
    "liveVitals": "Live Stats",
    "envoyNotReport": "La Gateway no está reportando",
    "microInverterNotReporting": "Los microinversores no generan reportes",
    "enpowerNotReporting": "El Controlador del sistema no está reportando.",
    "enchargeNotReporting": "La batería no está reportando",
    "enchargeError": "Error de la batería",
    "enpowerError": "Error del Controlador del sistema",
    "microinverters": "Microinversores",
    "stringInverters": "String Inverter",
    "storage": "Batería",
    "reconnectToEnvoy": "Conectividad",
    "configureWiFi": "Configurar wifi",
    "envoyInternetConnection": "Cambiar la conectividad a Internet de la Gateway",
    "enpower": "Controlador del sistema",
    "theme": "Tema",
    "darkmode": "Modo oscuro",
    "devmode": "Developer Mode",
    "appUpdate": "Actualizar la aplicación",
    "wifi": "Tipo de conexión",
    "feedback": "Comentarios",
    "logout": "Cerrar sesión",
    "help": "Ayuda",
    "siteid": "Número de Instalación",
    "visitTommorrowForReport": "Vuelva a comprobarlo mañana. La nube de Enphase no ha recopilado los datos necesarios para crear informes.",
    "email_report": "Reporte por Email",
    "will_send": "Será enviado a",
    "batterySubtitle": "Optimice su batería según el uso y la tarifa",
    "batteryEmeaSubtitle": "Optimice su batería según el uso",
    "connectivitySubtitle": "Cambie la conectividad a Internet de su Gateway",
    "eventsHistorySubtitle": "Ver el registro de eventos clave del sistema",
    "backupHistorySubtitle": "Ver el historial de apagones",
    "accountSubtitle": "Detalles personales, Idioma, La configuración de privacidad",
    "wifiSubtitle": "Ancho de banda estándar, Reporta datos en cada 15 minutos",
    "liveVitalsSubtitle": "Ver el estado en vivo del sistema",
    "themeSubtitleOn": "El modo oscuro está activado",
    "themeSubtitle": "El modo oscuro está apagado",
    "devmodeSubtitle": "Opciones del Modo Desarrollador",
    "appUpdateSubtitle": "Notas de la versión de las últimas actualizaciones y del cambio de registro",
    "appUpdateSuccessSubtitle": "La aplicación está actualizada",
    "requestReplacement": "Solicitud de reemplazo",
    "changeShippingAddress": "Cambiar la dirección de envío",
    "tariffEditor": "Precios de Electricidad",
    "tariffEditorNewMenu": "Precios de Electricidad",
    "currencyConversion": "Moneda equivalente",
    "currencyConversionNewMenu": "Moneda",
    "currencySubtitle": "Convierte datos de energía en tarifas de moneda equivalente",
    "showCurrency": "Mostrar moneda equivalente",
    "showCurrencySubtitle": "Encienda para mostrar el software de conversión",
    "passwordReset": "Reestablecer contraseña",
    "tariffAdded": "Ver/editar el esquema de precios de electricidad de su empresa de servicios públicos",
    "showCurrencySubtitleOff": "Apague para ocultar el software de la moneda",
    "tariffNotAdded": "No se agrega el esquema de precios de electricidad",
    "enlightenManager": "Ver en Enlighten Manager",
    "sgipIncentive": "Incentivo de almacenamiento (SGIP)",
    "gridServices": "Grid Services",
    "enphaseHome": "Me acabo de mudar a una vivienda que tiene Enphase",
    "systemAccess": "Está todo listo, pero requiere de acceso al sistema",
    "woSiteSystemAccess": "Acceso al sistema",
    "enphaseProducts": "Conocer más acerca de los productos Enphase",
    "enphaseTeam": "Obtener ayuda del equipo de Enphase",
    "gridSwitch": "Control de red",
    "onGrid": "Conectado a la Red (On)",
    "chatWithUs": "habla con nosotros",
    "referFriends": "Recomiende amigos",
    "referralTnC": "Términos y Condiciones",
    "hello": "Hola",
    "homeControls": "Home Controls",
    "systemDetails": "Sistema",
    "pesDetails": "System",
    "community": "Comunidad",
    "settingsMenu": "Configuraciones",
    "enphaseStore": "Enphase Store",
    "upgrades": "Upgrades",
    "services": "Servicios",
    "generatorSubtitle2": "Configura tu generador en base a perfiles inteligentes",
    "devicesSubtitle": "Ver todos los dispositivos y su estado",
    "siteDetailsSubtitle": "Ver detalles del sitio y del instalador",
    "reportsSubtitle": "Generar y enviar informes",
    "appSettings": "Ajustes de Aplicacion",
    "accountSettings": "Configuración de la cuenta",
    "addStorageSubtitle": "Añadir almacenamiento para evitar apagones",
    "addSolarPanels": "Añadir paneles solares",
    "addSolarPanelsSubtitle": "Aumente su autoconsumo",
    "sgipIncentiveSubtitle": "Solicite el incentivo SGIP",
    "gridServicesSubtitle": "Obtenga beneficios ayudando a la red con la Batería IQ",
    "incentives": "Incentivos",
    "accountMenu": "Cuenta",
    "myInformation": "Mi informacion",
    "myNotificationPreferences": "Mis Notificaciones",
    "myPrivacy": "Mi privacidad",
    "myAccessControl": "Mi control de acceso",
    "myInformationSubtitle": "Actualizar los detalles personales y del sistema",
    "myNotificationPreferencesSubtitle": "Gestionar mis notificaciones",
    "myPrivacySubtitle": "Controle cómo Enphase usa la información del sistema",
    "myAccessControlSubtitle": "Administrar el acceso a los datos del sistema",
    "systemSettings": "Ajustes del sistema",
    "deviceSettings": "Configuración de dispositivos",
    "wirelessRangeExtender": "Extensor de alcance de red inalámbrica",
    "cacheAction": "Borrar caché local",
    "cacheResult": "Datos de energía del navegador borrados",
    "noActiveNotices": "No hay reseñas activas para ti",
    "appInfo": "Información de la aplicación",
    "whatsNew": "Novedades",
    "privacyPolicy": "Política de privacidad",
    "tos": "Términos de servicio",
    "rateUs": "Califíquenos",
    "gridToggle": {
      "infoPopupTitle": "Sistema de Respaldo de Luz Solar",
      "infoPopupContentP1": "Su sistema es un Sistema de Respaldo de Luz Solar y no se recomienda cambiar a Fuera de Red fuera del tiempo de luz solar.",
      "pIt1": "Cuando el Sistema pasa a Fuera de Red, las cargas no esenciales se desconectan de la energía.",
      "pIt2": "Desconectarse Fuera de Red solo es posible durante las horas en las que las cargas esenciales están programadas para encenderse en %{scheduledMode}.",
      "pIt3": "Su sistema puede experimentar un apagado en Fuera de Red si no hay suficiente luz solar.",
      "scheduledMode​": "Modo programado",
      "infoPopupContentP2": "Cuando el sistema pasa a Fuera de Red, las cargas se desconectarán de la fuente de alimentación excepto la esencial. El cambio a Fuera de Red no está permitido fuera de las horas programadas. Su sistema puede experimentar un apagado en Fuera de Red si no hay suficiente luz solar."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Get to know your device",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Lleva tu energía contigo. Seguridad energética y energía sobre la marcha..",
      "enphasePESConnectDevice": "Conecte un Dispositivo",
      "enphasePESLearnMore": "Más información",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Register your device",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Make sure your phone’s Bluetooth is turned on.",
      "registerStep1": "Iniciar sesión/Registrarse en la cuenta de Enphase",
      "registerStep2": "Pair your device and phone via Bluetooth​",
      "registerStep3": "Give your device a name​",
      "registerStep4": "Connect it to the Wi-Fi network​",
      "register": "Register",
      "start": "Start",
      "later": "Later",
      "fserialNumber": "Enter Serial No.",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Name Your Device",
      "enterBoxName": "Device Name",
      "connectToWiFi": "Connect your device to Wi%{nbh}Fi",
      "connectToWiFiNotice": "Select your preferred Wi-Fi network and enter password.",
      "takeFewMinutes": "This may take a few minutes",
      "connectingToWifi": "Connecting to Wi-Fi",
      "pleaseContactSupport": "Please contact support for help",
      "unableToCompleteConnect": "Unable to complete the connect",
      "incomplete": "Incomplete",
      "congratulations": "Congratulations!",
      "incorrectPasswordTryAgain": "Incorrect password. Please try again",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "is registered",
      "startMonitoring": "Start Monitoring",
      "turnOnBluetoothOnNotice": "Your mobile bluetooth seems to be switched off. Please turn it on to connect to Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy Systems Around",
      "noOjasDevicesFound": "No Portable Energy System found",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Incorrect Code",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Capturing Device Details",
      "capturedDeviceDetails": "Device details captured",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Registration Error",
      "registrationErrorNotice": "Please retry registration. If problem persist, ",
      "deviceAlreadyRegistered": "Device already registered",
      "deviceAlreadyRegisteredNotice": "Este Sistema de Energía Portátil ya está registrado en otra cuenta de Enphase",
      "proceed": "Proceed",
      "rename": "Rename",
      "nameAlreadyExist": "Name already exist",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Bluetooth connection eshtablished!",
      "enter4DigitCode": "Enter 4 digit code",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Resend code",
      "connWithOJASBLE": "Connect with Portable Energy System via Bluetooth",
      "noBLEDevicesFound": "No bluetooth devices found",
      "backupTime": "Backup Time",
      "timeToCharge": "Time to Charge",
      "powerSaving": "Power Saving",
      "poweredOn": "Powered On",
      "powerOn": "Power On",
      "powerOff": "Power Off",
      "close": "Cerrar",
      "powerSavingHeader": "Device is Power Saving",
      "powerOnHeader": "Device is Powered On",
      "powerSavingSubHeader": "(AC output disabled)",
      "powerSavingContent": "You can remotely power on and enable AC output or shut down the device and disable all the input and output power supply.",
      "powerOnContent": "You can remotely shut down the device and disable all the input and output power supply.",
      "shuttingDown": "Shutting down in",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "El dispositivo no está conectado a la aplicación de Enphase.",
        "1_description": "Please ensure your device is turned on and connected to Wi-Fi. If you are nearby your device, you can pair your phone with the device using Bluetooth.",
        "1_action": "Connect using Bluetooth",
        "3_title": "Bluetooth not supported!",
        "3_description": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
        "4_title": "Turn On Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Scanning for Bluetooth devices...",
        "7_title": "Bluetooth devices",
        "8_title_success": "No bluetooth devices found.",
        "8_title_error": "Problem persisted while scanning.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Eshtablish Bluetooth connection...",
        "10_title": "Enter proof of possession PIN for",
        "10_subTitle": "Proof of Possession PIN",
        "11_title": "Bluetooth connection established!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " is successfully eshtablished.",
        "12_title": "Bluetooth Not-Connected.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " is failed, Please try again.",
        "13_title": "Searching for Wi-Fi networks...",
        "14_title": "Connect PES to Wi-Fi",
        "14_description": "Select your preferred Wi-Fi network and enter password.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "No Wi-Fi network found.",
        "15_title_error": "Problem persisted while scanning.",
        "15_description": "No Wi-Fi network found. Reboot your Wi-Fi router and try again.",
        "18_title_1": "Sending Wi-Fi credentials",
        "18_title_2": "Applying Wi-Fi connection",
        "18_description": "provisioned successfully,",
        "19_title": "Incomplete!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Device ID",
      "ojasSettings": {
        "profile": "Perfiles",
        "acPorts": "Puertos de CA",
        "dcPorts": "Puertos DC",
        "on": "Encendido",
        "off": "Apagado",
        "brightnesSettings": {
          "brightness": "Brillo",
          "customBrightness": "Brillo personalizado",
          "auto": "Ajustar automáticamente el brillo"
        },
        "lightSettings": {
          "light": "Luz",
          "on": "Siempre encendida",
          "off": "Siempre apagado",
          "auto": "Automático",
          "onMsg": "Se mantiene encendida",
          "autoMsg": "Se enciende cuando hay alguien cerca",
          "offMsg": "Se mantiene apagada"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Encendido",
          "powerOff": "Apagado",
          "powerSave": "Ahorro de energía"
        },
        "ojasModes": {
          "on": "Todos los puertos de salida de CA y CC están encendidos. Mantenga el dispositivo en este modo si tiene sus herramientas o aparatos conectados al puerto de CA.",
          "save": "Solo los puertos de CC están encendidos y listos para alimentar dispositivos electrónicos. Este modo ahorra energía porque los puertos de CA están apagados.",
          "off": "Todas las fuentes de alimentación de entrada y salida estarán apagadas."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Ahorros",
    "appTutorialPage": {
      'all-topics-empty': 'No hay temas disponibles',
      'videos-empty': 'No hay videos disponibles',
      'articles-empty': 'No hay artículos disponibles',
      'noResults': "No hay resultados para \"%{searchValue}\""
    }
  },
  "environmentCard": (_environmentCard = {
    "title": "Ambiente",
    "label": "Impacto medioambiental",
    "rightText": "Fuente: epa.gov",
    "equivalent": "Equivalente",
    "trees": "árboles",
    "tree": "árbol",
    "planted": "PLANTADOS",
    "carbon_offset": "COMPENSACIÓN DE EMISIONES DE CARBONO",
    "charged": "CARGADO",
    "phones": "teléfonos",
    "phone": "teléfono",
    "tonnes": "toneladas",
    "tonne": "tonelada"
  }, _defineProperty(_environmentCard, "trees", {
    "zero": "árboles",
    "one": "árbol",
    "other": "árboles"
  }), _defineProperty(_environmentCard, "phone", {
    "one": "teléfono",
    "other": "teléfonos"
  }), _defineProperty(_environmentCard, "tonne", {
    "one": "tonelada",
    "other": "toneladas"
  }), _defineProperty(_environmentCard, "lb", {
    "one": "libra",
    "other": "libras"
  }), _defineProperty(_environmentCard, "ton", {
    "one": "tonelada",
    "other": "montones"
  }), _environmentCard),
  "connectionType": {
    "wifi": "Wi-Fi",
    "cellular": "Módem de celda",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Reporta datos cada 15 minutos",
    "reportsAt6Hrs": "Reporta datos cada 6 horas",
    "idle": "Inactivo",
    "notAvailable": "No disponible",
    "configureWiFiSettings": "Configurar ajustes inalámbricos",
    "configureWiFiSettings2": "Configurar",
    "switchToWiFi": "Cambiar a Wi-Fi",
    "connectToWiFi": "Conectarse a Wi-Fi"
  },
  "details": {
    "connection_type": "Tipo de conexión",
    "description": "Descripción del sistema",
    "installer": "Instalado por",
    "maintainer": "Mantenedor del sistema",
    "micros": {
      "one": "Microinversor",
      "other": "Microinversores"
    },
    "acbs": {
      "one": "Batería",
      "other": "Baterías"
    },
    "arrays": {
      "one": "Conjunto de paneles",
      "other": "Conjuntos de paneles"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% más que ayer a esta hora",
    "less_yesterday": "% menos que ayer a esta hora",
    "same_yesterday": "Casi lo mismo que ayer a esta hora",
    "more_last_year": "% más que el año pasado a esta hora",
    "less_last_year": "% menos que el año pasado a esta hora",
    "same_last_year": "Casi lo mismo que el año pasado a esta hora",
    "more_yesterday_prev": "% más que esta vez el día anterior",
    "less_yesterday_prev": "% menos que a esta hora el día anterior",
    "same_yesterday_prev": "Más o menos igual que esta hora el día anterior",
    "more_last_year_prev": "% más que esta vez el año anterior",
    "less_last_year_prev": "% menos que esta vez el año anterior",
    "same_last_year_prev": "Más o menos igual que este último año anterior",
    "system": "Sistema",
    "emptyArray": "No hay ningún diseño de conjunto de paneles disponible",
    "storageArray": "Matriz de almacenamiento",
    "solarArray": "Panel solar",
    "contactInstForpersonalizedLayout": "Póngase en contacto con su instalador para obtener una vista personalizada de su conjunto de unidades de almacenamiento.",
    "cntcInstPopP1": "“Unidades de almacenamiento“ muestra la imagen del conjunto de unidades de almacenamiento instaladas en su casa junto con sus niveles de carga.",
    "cntcInstPopP2": "Póngase en contacto con el instalador para configurar el conjunto de unidades de almacenamiento en la aplicación Installer Toolkit o Enlighten Manager para obtener una vista más personalizada."
  },
  "support": {
    "enphase": "Soporte de Enphase",
    "enphaseLink": "Soporte de Enphase",
    "maintainer": "Soporte técnico y mantenimiento del sistema",
    "maintainerLink": "Contactar con responsable de mantenimiento",
    "contactEnphase": "Enphase de contacto",
    "enphaseSupport": "Soporte de Enphase",
    "ensembleSupport": "Llamada Ensemble Support",
    "writeToUs": "Escríbenos",
    "visitSupport": "Visitar soporte",
    "talkToUs": "Habla con nosotros",
    "talkToUsAnytime": "Habla con nosotros en cualquier momento",
    "customerSupport24by7": "Soporte al cliente 24/7",
    "needHelpTitle": "Necesita ayuda con",
    "needMoreHelpTitle": "Necesitamos más ayuda",
    "microinvertersNotReporting": "Los microinversores no informan",
    "productionDifference": "Diferencia en producción por panel",
    "contactUs": "Contáctenos",
    "askEnphaseCommunity": "Pregunta a la comunidad de Enphase",
    "browseTopics": "Explorar todos los temas de ayuda",
    "chatWithUs": "habla con nosotros",
    "productionIssue": "Problema de producción",
    "envoyNotReporting": "El sistema o la Gateway no están reportando",
    "helpTopics": "Temas de ayuda",
    "brwsAllFaqs": "Examinar todas las preguntas frecuentes",
    "askEnphaseCommunitySubtitle": "Contacte con otros clientes de Enphase de su entorno",
    "systemOwnerGuide": "Consulte la guía del propietario del sistema",
    "faq": {
      "usingManualOverride": "Uso de anulación manual",
      "understandingEnpower": "Entendiendo a IQ System Controller",
      "understandingEncharge": "Entendiendo a IQ Battery",
      "understandIQCombiner": "Cómo funciona el IQ Combiner, la Gateway, el kit de comunicación y el módem móvil",
      "stormGaurdFeatureDetails": "Detalles de la función Alerta de tormenta",
      "settingElectricityRateStructure": "Configuración de la estructura de las tarifas de electricidad",
      "recoverShutdownLL": "Recuperación del Apagado debido a Grandes cargas",
      "recoverShutdownCF": "Recuperación del Apagado debido a una Falla de comunicaciones",
      "recoverShutdownBD": "Recuperándose del Apagado por Agotamiento de la batería",
      "PowerHomeInBCK": "Alimentando cargas domésticas en respaldo",
      "partialHomeBCK": "Configuración de respaldo de vivienda parcial",
      "monitorUrSys": "Supervisando su sistema",
      "mngLgApplianceBck": "Administrar Dispositivos grandes en Respaldo",
      "incentivesAvlbTou": "Incentivos disponibles para usted",
      "grdTrnxToOffGrd": "Transición de la red a fuera de la red",
      "allHomeBck": "Configuración de respaldo completa en la vivienda",
      "envLEDstatus": "Estado de la luz LED de la Gateway",
      "dsgnUrSys": "Diseñando su sistema",
      "cntctCustSupp": "Contactando con el Servicio de atención al cliente",
      "batSmrtPrfSel": "Seleccione el perfil de batería inteligente",
      "accsEnchrgDcswtch": "Acceder al interruptor de CC de las baterías",
      "mcrInvNtReprt": "El microinversor no informa",
      "sysEnvNtReprt": "La Gateway no está reportando",
      "hwUrSysWrk": "Cómo funciona su sistema",
      "enchrLedStatus": "Estados de la luz LED de la batería",
      "noPwNebDo": "Mi casa no tiene luz pero mis vecinos sí",
      "consBatDurGridOut": "Ahorre batería durante un corte de red",
      "emgSupCallSteps": "Seleccione 2 para soporte al cliente y 1 para propietarios de sistemas. Seleccione 2 en el submenú para soporte de almacenamiento.",
      "preLoginCallSteps": "Seleccione 2 para atención al cliente o seleccione 4 para ventas.",
      "sysProdIssue": "Problema de producción del sistema",
      "diffInPerPanProd": "Diferencia de producción por panel",
      "installCellModem": "Guía de instalación del módem celular",
      "whatIsEI": "Puntaje de Independencia de energía",
      "howEnHomeEngSysWork": "¿Cómo funciona el sistema energético doméstico de Enphase?",
      "understandEnv": "Cómo funciona la Gateway",
      "findEnv": "Encontrar mi Gateway",
      "envReplaced": "La Gateway ha sido reemplazada",
      "rebootEnv": "Reanudar o reiniciar la Gateway",
      "hwChangeEmail": "¿Cómo cambio mi correo electrónico?",
      "hwResetPasswd": "¿Cómo puedo restablecer mi contraseña?",
      "accessEnvLocalIntf": "Acceder a la interfaz local de la Gateway",
      "envLocIntfLogCred": "Credenciales de inicio de sesión de interfaz local de la Gateway",
      "hwDisbaleNotification": "¿Cómo activo y desactivo los informes mensuales y otras notificaciones por correo electrónico?",
      "MontEngProd": "Seguimiento de mi producción de energía",
      "whyNotSeeConsumption": "¿Por qué no puedo ver mi consumo?",
      "hwMonConsumpt": "¿Cómo puedo controlar el consumo de mi hogar?",
      "calEngUsageWoConsumptionMonitoring": "Calcular mi consumo de energía sin monitorizar el consumo",
      "undersNetEng": "Entendiendo la energía neta",
      "understTrueUpStmt": "Comprensión de una declaración de Ture-up",
      "diffPaidENLMvsPerpanelDataaoffering": "Diferencia entre Enlighten Manager pagado y oferta gratuita de datos de energía por panel",
      "blkInPerpanMon": "Panel negro en vista de panel",
      "gryorBlnkInPerpanMon": "Panel gris (en blanco) en la vista de panel",
      "hwToMovePnl": "¿Cómo mover un panel?",
      "hwfindInst": "¿Cómo encontrar un nuevo instalador?",
      "whtdoIfonePanelNotreproduc": "¿Qué debo hacer si uno de los paneles tiene poca o ninguna producción?",
      "haveaSelfPoweredHome": "¿Qué significa tener un hogar autoalimentado?",
      "yourSystemPaysForItself": "¿En cuánto tiempo se amortiza su sistema?",
      "enphaseSystemsAreSafe": "¿Por qué los sistemas Enphase son seguros?"
    },
    "webBackButton": "Atrás",
    "supportHistory": "Historial de soporte"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Añadir un vehículo eléctrico",
    "addevSub": "Háganos saber si está utilizando su sistema Enphase para cargar su vehículo eléctrico para que podamos proporcionarle información y recomendarle plazos óptimos para cargar su vehículo de forma eficiente.",
    "haveEv": "Tengo un VE.",
    "qbrand": "¿Cuál es la Marca de su VE?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "¿Cuál es el nombre del modelo de su VE?",
    "diffcharger": "Cargo mi VE en casa con un cargador de otra empresa",
    "qcharger": "¿Cuál es la Marca de su Cargador?",
    "qcapacity": "¿Cuál es la capacidad de la batería de su VE (en kWh)?",
    "notcompulsory": "*Esta pregunta no es obligatoria. Puede omitirla si no la conoce.",
    "qtime": "¿Cuándo carga su vehículo?",
    "morning": "Por la mañana",
    "afternoon": "Por la tarde",
    "evening": "Por el anochecer",
    "night": "Por la noche",
    "other": "Otro (por favor, especifique)",
    "qmiles": "¿Cuántos kilómetros suele recorrer al día?",
    "brand": "Detalles de la marca",
    "tech": "Datos técnicos",
    "operational": "Detalles operativos",
    "ev": "Vehículo eléctrico:",
    "suggsch": "Horario sugerido",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Eliminar el vehículo eléctrico",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Activar Storm Guard",
    "stormGuardEnablePopUpFooter": "¿Desea activar Storm Guard?",
    "stormGuardDisablePopUpHeader": "Desactivar Storm Guard",
    "stormGuardDisablePopUpFooter": "¿Igualmente desea desactivar Storm Guard?",
    "backupTime": "Tiempo de respaldo",
    "encharge_battery": "Seleccione un perfil inteligente para controlar su batería",
    "encharge_battery_emea": "Perfil inteligente para controlar tu batería",
    "savings": "Modo ahorro",
    "expert": "Modo experto",
    "self-consumption": "Autoconsumo",
    "battery_bkup": "Reserva completa",
    "savings_text": "Se usa si los costos de energía varían durante el día. La batería se carga fuera de las horas pico y se usa durante las horas pico y después que se pone el sol.",
    "savings_mode_notSet": "Maximiza sus ahorros en base a las tarifas de electricidad",
    "savings_mode_dc_tou": "La energía solar y la batería se usan durante las horas pico para minimizar la importación de electricidad de la red.",
    "savings_mode_dc_all_day": "Durante las horas pico se exporta energía solar a la red. La batería alimenta su hogar hasta que llega a la carga de reserva.",
    "viewElectricityRate": "Ver las tarifas de electricidad",
    "optForDC": "Optimizado para ahorro de cargos por demanda",
    "optForIncExport": "Optimizado para aumentar la exportación",
    "consumption_text": "Usa la energía solar almacenada para alimentar su hogar después que se pone el sol. La batería se usa cuando la energía solar no está disponible.",
    "consumption_text_pv_yield": "Cargue la batería durante las horas pico de producción para optimizar la producción fotovoltaica. La batería se usa cuando la energía solar no está disponible.",
    "bkup_text": "100 % de la batería se guarda para reserva.",
    "reserve": "Reserva",
    "optimization": "Optimización basada en",
    "utility_rates": "Tarifas de servicio público",
    "increase_consumtion": "Incrementar el Autoconsumo a",
    "max_consumption": "Maximizar La Independencia Energética",
    "optimize_pv_production": "Optimice la producción fotovoltaica",
    "activate": "Activar",
    "active": "Activo",
    "save": "Guardar",
    "edit": "EDITAR",
    "error": "No se puede guardar la configuración de almacenamiento.",
    "requestTakingLonger": "La solicitud está demorando más de lo esperado. Vuelva a intentarlo más tarde",
    "batterySettingsTakingLonger": "La actualización de la configuración de la batería está demorando más de lo esperado. Vuelva a intentarlo más tarde",
    "completed": "La configuración de la batería se ha actualizado correctamente.",
    "completedAdvance": "La Configuración Avanzada de la Batería se ha actualizado correctamente.",
    "requestPending": "Solicitud pendiente. Esperando confirmación de la gateway Vuelva a comprobarlo más tarde.",
    "editRequest": "Tiene una solicitud activa. Espere la confirmación o cancele esa solicitud para continuar con la selección.",
    "editRequestVls": "Tiene una solicitud activa en la Configuración Avanzada de la Batería. Espere la confirmación o cancele la solicitud para proceder a la selección.",
    "cancelRequest": "Su solicitud ha sido cancelada.",
    "updatedSuccesfully": "Actualizado exitosamente",
    "pendingRequestText": "Dejar pendiente la solicitud",
    "cancelRequestText": "Cancelar la solicitud",
    "pendingText": "Pendiente",
    "processingText": "Procesando",
    "battery_reserve": "de energía almacenada se guardará de reserva",
    "cancelFailed": "No se pudo cancelar la tarea.",
    "noPendingTask": "El sistema no tiene ninguna tarea pendiente para cancelar.",
    "noEncharges": "El sistema no tiene baterías",
    "severeWeatherText": "Protector de tormentas",
    "disabled": "Desactivado",
    "enabled": "Habilitado",
    "weatherWatchDescription": "Reemplaza su perfil de batería al modo de respaldo completo cuando se emite una alerta de condiciones climáticas severas para su localidad.",
    "disabledModeInfo": "Cuando se activa, Enphase se comunica con el {%s} para detectar alertas de eventos climáticos severos y establece su perfil de batería en modo de respaldo completo para proporcionar respaldo durante el evento. Después de que el evento haya pasado, el perfil de la batería volverá a su configuración anterior.",
    "enabledModeInfo": "Enphase se comunicará con el {%s} para detectar alertas de eventos climáticos severos y pondrá su perfil de batería en modo de respaldo completo. Después del evento, el perfil de la batería volverá a su configuración anterior.",
    "activeModeInfo": "Enphase detectó una alerta de evento meteorológico severo del {%s} y su perfil de batería se establece en modo de respaldo completo. Después de la hora de finalización del evento, el perfil de la batería volverá a su configuración anterior.",
    "stormGuardModeInfo": "Cuando %{status}, la función de ‘Storm Guard’ monitorea las alertas de eventos atmosféricos severos emitidos por el %{nws}. Automáticamente cambia el perfil de la batería a ‘Reserva Completa’ si una aviso es emitido en su región. Esto permite que la capacidad completa de reserva de su batería esté disponible ante la posibilidad de un apagón.%{nl}Si un aviso es emitido para su región, ‘Alerta de Tormenta: Acdtivado’ aparecerá en la sección de ‘Perfil’ en la página de Estatus y Estatus en Vivo.Al mismo tiempo, su perfil de batería se establecerá en el modo ‘Resrva Completa’.%{nl}Después de que el aviso termine, el perfil de la batería regresará a su configuración original.",
    "editActiveWeatherAlert": "Protector de tormentas activo. Espere a que el evento pase (recomendado) o desactive el protector de tormentas para proceder con la selección.",
    "enabledToActiveAlert": "Enphase detectó una alerta de evento meteorológico severo del servicio meteorológico nacional y su perfil de batería se establecerá en modo de respaldo completo. Después de la hora de finalización del evento, el perfil de la batería volverá a su configuración anterior.",
    "activeToEnabledAlert": "El evento de clima severo ha pasado y su perfil de batería volverá a su configuración previa.",
    "okayText": "¡Bien, lo hizo!",
    "disclaimerText": "La función Alerta de tormenta utiliza información procedente de la administración nacional oceánica y atmosférica/servicio meteorológico nacional de EE. UU., como (sin limitación) alertas de clima severo, cuya información es de dominio público y no está sujeta a protección de derechos de autor. Enphase no pretende poseer ni controlar dicha información. Usted acepta expresamente que el uso de esta función es bajo su propio riesgo. Y asume todo el riesgo relacionado con la habilitación de esta función y cualquier uso posterior. Enphase proporciona dicha información a través de la función Alerta de tormenta 'tal como es', y renuncia a todas y cada una de las garantías, ya sean expresas o implícitas, incluida (sin limitación) cualquier garantía implícita de comerciabilidad o idoneidad para un propósito particular. En ningún caso, Enphase será responsable ante usted o cualquier tercero por daños directos, indirectos, incidentales, consecuentes, especiales o ejemplares o pérdida de imagen como resultado de cualquier uso o mal uso de estos datos.",
    "disclaimer": "Renuncia",
    "agreeText": "De acuerdo y continuar",
    "disagreeText": "No estar de acuerdo",
    "nationalWeather": "Servicio Meteorológico Nacional (NWS)",
    "dataNotAvailable": "NA",
    "errorTitle": "Error",
    "errorCode": "Código de error",
    "thresholdError": "Reporting Error",
    "PopupError": "El Núm. de serie de su batería",
    "thresholdPopupError": "¿No reportó durante el último ciclo de informes? Por lo tanto, el % de almacenamiento acumulado excluye el % de almacenamiento para esta batería. La batería debería comenzar a reportar con el siguiente ciclo de informes. Póngase en contacto con el Servicio de Atención al Cliente si el problema persiste.",
    "errorPopup1": "tiene un problema (Desc.",
    "errorPopup2": ", Código de error:",
    "errorPopup3": "). Este evento de errores hace que el % de almacenamiento reportado de esta batería no sea confiable. Por lo tanto, el porcentaje de almacenamiento acumulado mencionado anteriormente excluye el porcentaje de almacenamiento de esta batería. Póngase en contacto con el Servicio de Atención al Cliente si el problema persiste.",
    "contactSupport": "Contacte al Servicio de Soporte",
    "errorSubmitButton": "Ok. Entendido",
    "microinvertorError": "El microinversor de la batería no está activo",
    "microinvertorsError": "Los microinversores de la batería no están activos",
    "touAlert": "El Modo de Ahorro solo funciona si la tasa de importación de electricidad varía con el tiempo de uso. Actualice su tasa de importación de electricidad para habilitar este modo.",
    "touAlert2": "Configure su tarifa de importación de electricidad como ToU y el plan de tarifas de exportación como NEM para activar el modo de ahorro.%{nl}El modo de ahorro solo funciona si tiene un Medidor de Energía Neta (NEM, Net Energy Metering) y su tarifa de electricidad varía con el Tiempo de uso (ToU, Time of Use).",
    "touAlert3": "Configure su tarifa de importación de electricidad como ToU para activar el modo de ahorro",
    "touAlert4": "Configure su plan de exportación de electricidad para habilitar el modo de ahorro",
    "updateElectricityRate": "Actualizar Tarifa de electricidad",
    "batteryChangeAlert": "El perfil de la batería se cambió al Modo de Autoconsumo ya que el Modo de Ahorro solo funciona si la tasa de importación de electricidad varía con el tiempo de uso.",
    "batteryChangeAlert2": "Su perfil de batería se ha cambiado al modo de autoconsumo, ya que el modo de ahorro solo funciona si tiene un Medidor de Energía Neta (NEM, Net Energy Metering) y su tarifa de electricidad varía con el Tiempo de uso (ToU, Time of Use).",
    "viewDetails": "Ver detalles",
    "ok": "Aceptar",
    "systemRequest": "Las solicitudes generadas por el sistema no se pueden cancelar.",
    "featureDetailsButton": "Detalles de la función Storm Guard",
    "stormGuardEnablePopUp": "Activar Storm Guard le permite reservar la totalidad de la capacidad de batería para usar durante un posible corte de energía, cambiando el perfil de batería a 'Respaldo total' en caso de alertas meteorológicas graves.",
    "stormGuardDisablePopUp": "No se recomienda desactivar Storm Guard. En caso de alerta meteorológica grave, le ayuda a estar protegido de cortes de energía debido al mal tiempo.",
    "batterySmartProfile": {
      "title": "Seleccione el perfil de batería inteligente",
      "description": "Aprenda a elegir el perfil correcto para el sistema de baterías",
      "viewDetails": "Ver detalles"
    },
    "reserveDisclaimer": "La reserva de batería no se puede establecer por debajo del %{minSoc}%. Se almacena un mínimo del  %{minSoc}% de energía en la batería para alimentar las cargas críticas de su vivienda durante un corte de red.",
    "eIpopDesc": "%{enabled}: Su batería se descarga para ahorrar dinero durante las horas pico cuando los precios de la electricidad son altos. Una vez hecho esto, se dará prioridad a la Independencia Energética. Esto aumentará su autosuficiencia energética hasta que alcance la carga de respaldo de la batería. Su batería se cargará con energía solar por la mañana para prepararse para el próximo período pico.%{nl}%{disabled}: Su batería solo se descargará durante las horas pico cuando la tarifa eléctrica es alta. En otras ocasiones, la batería está inactiva o se carga con energía solar por la mañana para prepararse para el próximo período pico.",
    "errActiveCostSave": "Active el Modo de Ahorro para utilizar esta función",
    "eiDescreption": "Independencia energética después de las horas pico",
    "advSetting": {
      "cfg": {
        "title": "Cargue la batería de la red",
        "descrDisable": "Your battery is charged from Solar.",
        "descrEnabled": "La batería se carga desde Solar. También puede cargarse desde la red cuando la batería está en el modo de respaldo total o cuando la carga de la batería está por debajo de la capacidad de reserva en los modos de ahorro o autoconsumo.",
        "descrEnabledFR": "Su batería se cargará de la red en el intervalo programado. No se descargará durante este periodo.",
        "popUpDescrFR": "%{enabled}: Su batería se cargará de la red en el intervalo programado. No se descargará durante este periodo. %{nl}%{disabled}: Su batería se carga con energía solar.",
        "popUpDescr": "%{enabled}: La batería se carga desde Solar. También puede cargarse desde la red cuando la batería está en el modo de respaldo total o cuando la carga de la batería está por debajo de la capacidad de reserva en los modos de ahorro o autoconsumo.%{nl}%{disabled}: Your battery is charged from Solar.",
        "disclaimer": "El uso de una fuente de energía no renovable para cargar el sistema de almacenamiento de Enphase puede afectar su elegibilidad para el ITC. Para obtener más información, comuníquese con su asesor fiscal.",
        "dlgTitle": "¿Cargar desde la red?",
        "dlgInfo": "Una vez activada, su batería se cargará de la red en el intervalo programado. No se descargará durante este periodo. Compruebe las normas de la compañía eléctrica antes de activar esta opción.",
        "selfDeclrFR": "Entiendo que la carga de la red puede ir en contra de las normas de la compañía eléctrica.",
        "selectSchedule": "Seleccione el horario para cargar su batería desde la red.",
        "titleFR": "Horario de carga desde la red",
        "saveSch": "Guardar horario",
        "chargeSch": "Horario de carga",
        "selfDeclr": "Entiendo que mi elegibilidad para reclamar el Crédito Tributario por Inversión puede verse afectada.​",
        "disclaimer_itk": "El uso de una fuente de energía no renovable para modificar el sistema de almacenamiento de Enphase puede afectar la elegibilidad de una reclamación de la ITC. Comuníquese con el propietario para obtener su aprobación.",
        "selfDeclr_itk": "El propietario entiende que la elegibilidad para reclamar el Crédito Tributario por Inversión puede verse afectada.",
        "activeStormAlert": "Hay una alerta de tormenta para su sistema. Espere a que termine la alerta para actualizar esta configuración."
      }
    },
    "exM": {
      "title": "Modo experto",
      "subTitle1": "Programar perfiles de las baterías",
      "subTitle2": "Perfiles de las baterías programados",
      "schedule": "Programar",
      "tariffNotSetDlgtitle": "Tarifa de Electricidad No Establecida",
      "tariffNotSetDlgContent": "Configure su tarifa eléctrica para activar el modo de ahorro.%{nl}Enphase necesita los detalles de su tarifa para determinar el mejor horario para su batería.",
      "setRate": "Establecer tarifa",
      "tariffUpdateDlgtitle": "Actualizar tarifa de electricidad",
      "tariffUpdateDlgContent": "El modo de ahorro solo funciona si tiene medición de energía neta (NEM) y su tarifa de electricidad varía según el tiempo de uso (ToU)",
      "updateRate": "Actualizar tarifa",
      "setNemDlgTitle": "Tarifa de exportación de electricidad no establecida",
      "setNemDlgContent": "Establezca su tarifa de importación de electricidad como NEM para habilitar este modo.",
      "setNemCta": "Establecer como NEM",
      "preview": "Vista previa",
      "addBatProfile": "Agregar perfil de batería",
      "pViewPop": {
        "l1": "La gráfica representa los perfiles de las baterías programados para un período de 24 Hrs.",
        "l2": "La reserva de la batería se aplica solamente al modo de autoconsumo y ahorro. Si está en respaldo total, su reserva de batería será del 100%.",
        "l3": "Maximiza su independencia energética",
        "l4": "Maximiza sus ahorros en base a las tarifas de electricidad",
        "l5": "Conserva el 100% de la energía de la batería para respaldo",
        "batteryProfiles": "Perfiles de batería"
      },
      "batReserveDisclaimer": "La reserva de la batería se aplica solamente al modo de autoconsumo y ahorro. Si está en respaldo total, su reserva de batería será del 100%."
    },
    "prfAssist": {
      "t0": "Ya está en el perfil recomendado",
      "t1": "Recomendamos",
      "t2": "Modo de ahorro con una reserva baja de batería y la opción de independencia energética activada.",
      "t3": "Modo de ahorro con una reserva baja de batería y la opción de independencia energética desactivada.",
      "t4": "Modo de autoconsumo con una reserva baja de batería.",
      "t5": "Modo de autoconsumo con una reserva moderada de batería.",
      "t6": "Modo de respaldo total.",
      "t7": "Modo de ahorro con una reserva alta de batería y la opción de independencia energética desactivada.",
      "t8": "Modo de autoconsumo con una reserva alta de batería.",
      "batResText": "Reserva de batería entre",
      "learnHowEmea": "Más información sobre el perfil de la batería",
      "learnHow": "Aprenda cómo funcionan los perfiles de batería",
      "editPref": "Editar preferencias",
      "c1": "Ahorrar dinero",
      "c1Sub": "Llevar al máximo el ahorro en las facturas mensuales",
      "c2": "Independencia energética",
      "c2Sub": "Autosuministrar energía a su hogar y ser más ecológico",
      "c3": "Respaldo",
      "c3Sub": "Respaldo durante los apagones",
      "p1": "Primera prioridad",
      "p2": "Segunda prioridad ",
      "optional": "Opcional",
      "ques": "¿Cuáles son sus expectativas con respecto al sistema Enphase?",
      "priority": "Arrastre y coloque las metas en orden desde la más importante a la menos importante.",
      "ftrpTutorialText": "Seleccione y arrastre las tarjetas hacia arriba o abajo según su prioridad. La primera tarjeta desde arriba representa la mayor prioridad.",
      "updateBatteryProfile": "Actualizar perfil de batería",
      "activatedSavingsMode": "Su batería está actualmente en Modo de ahorro con una reserva de %{soc}% y la Independencia energética después de las horas pico es de %{eiStatus}.",
      "activatedSelfConsumptionMode": "Su batería está actualmente en Autoconsumo con una reserva de %{soc}%.",
      "activatedFullBackupMode": "Su perfil de batería actual es de Respaldo total.",
      "activatedSavingsModeWithoutSoc": "Su batería está actualmente en Modo de Ahorro y la Independencia Energética después de las horas punta es %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Su batería está actualmente en Autoconsumo.",
      "activateProfile": "¿Desea activar el perfil recomendado?"
    }
  },
  "envoy": {
    "all": "Todas las puertas de enlace",
    "pvAll": "Todo",
    "dropDwnHelper": "Mostrar datos de",
    "envSN": "NS Pasarela:",
    "reconnect": "Vuelva a conectar su Puerta de enlace.",
    "extraContent": "Mientras tanto, si está cerca de su sistema, puede conectarse localmente con la Puerta de enlace para ver el estado actual.",
    "btnText": "Aprenda a conectarse al Wi-Fi de la Puerta de enlace",
    "getHelp": "Conecte su Gateway nuevamente al Wi-Fi del hogar",
    "envoyConfirmation": "Conecte la Gateway mediante el modo AP para continuar.",
    "title": "Hemos encontrado que ha estado usando Envoy-S o IQ Gateway y usando Wi-Fi.",
    "steps": "Siga los pasos para conectar la Gateway a la red de Wi-Fi",
    "steps_ap": "Siga los pasos para conectarse a la red de la Puerta de Enlace",
    "ap_button": "Presione el botón modo AP",
    "ap_modeDescription": "Presione brevemente y suelte (no mantenga presionado) el botón del menú de la Gateway debajo del ícono del teléfono. Esto habilitará el Modo AP en su Gateway que crea una red inalámbrica a la que puede unirse con su teléfono.",
    "disable_data": "Desactivar datos móviles",
    "disable_dataDescription": "Desactive los datos móviles (datos del celular) desde la configuración de su dispositivo móvil. Vaya a configuración > Datos móviles y desconéctelo.",
    "envoy_network": "Únase a la red de la Gateway",
    "envoy_description": "Únase a la red de la Gateway usando la configuración de Wi-Fi de su teléfono. Envoy_029655 es el nombre de la mini-red a la que se unirá, donde \"029655\" son los últimos seis dígitos del número de serie de su Gateway",
    "home_wifi": "Conecte la Gateway al Wi-Fi del hogar",
    "wifi_description": "Toque el botón configurar wifi de la casa, seleccione la red de su casa e ingrese la contraseña de wifi.",
    "configure_wifi": "Configurar el wifi de la casa",
    "cancel": "Cancelar",
    "stickyNotification": "No toque el botón de regresar ni cierre la aplicación (puede minimizarla) mientras está intentando reconectarse a su Gateway",
    "enter_password": "Ingresar contraseña para",
    "password": "Contraseña",
    "incorrect_password": "Contraseña incorrecta",
    "wifi_failureMsg": "La Gateway no pudo conectase a su red de Wi-Fi",
    "wifi_successMsg": "La Gateway fue conectada al Wi-Fi con éxito",
    "envoyConnectToCellular": "Ahora puede desconectar su dispositivo móvil de la red de la Gateway y conectarlo a su Wi-Fi / habilitar sus datos móviles.",
    "envoyToastMessage": "Su Gateway fue conectada con éxito. Pero podría tomar hasta 30 minutos para que el estado de su Gateway se actualice.",
    "wifi_congratsMsg": "¡Felicitaciones! Está de vuelta en línea. Ahora puede volver a conectar su móvil a la red de wifi .",
    "tryagain": "Inténtelo de nuevo",
    "okay": "Bien, lo hizo",
    "failedToFetchWiFiNetworks": "Problemas para obtener redes Wi-Fi. Inténtelo de nuevo después de algún tiempo.",
    "noWifiNetworkFound": "No se encontró ninguna red Wi-Fi. Reinicie su enrutador Wi-Fi y vuelva a intentarlo.",
    "option2": "Si los pasos anteriores no funcionan, aprenda cómo puede hacerlo manualmente",
    "learnhow": "Aprender cómo",
    "ensureOn": "Cerciórese de que la Gateway esté encendida",
    "connectToPower": "Cerciórese de que su Gateway esté conectada a una fuente de alimentación."
  },
  "whatsnews": {
    "monitorTitle": "Supervisar",
    "monitorContent": "Compruebe el estado de su sistema rápidamente gracias a la visualización de las métricas clave en una única pantalla. ",
    "trackTitle": "Seguimiento",
    "trackContent": "Siga y navegue por sus tendencias de consumo y generación de energía por día, mes, año o el periodo que desee.",
    "reportTitle": "Reporte",
    "reportContent": "Genere reportes sobre el uso y la generación de energía en la aplicación por día, semana, mes o el periodo que desee."
  },
  "theme": {
    "instructions": "Esquema cromático actual",
    "night": "Noche",
    "day": "Día"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Cargas",
    "generator": "Générateur",
    "noDeviceFound": "Dispositivo no encontrado",
    "searchMicroinverters": "Buscar microinversores SN",
    "serialNumber": "SN",
    "configure": "Configurar",
    "connect": "Conectar",
    "envoy": "Gateway",
    "microinverters": "Microinversores",
    "microinverter": "Microinversor",
    "stringInverters": "String Inverter",
    "storage": "Batería",
    "enpower": "Controlador del sistema",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Recuento de ciclos",
    "cycleCountInfo": "El recuento de ciclos para una batería es el número total de ciclos completos de carga y descarga. Se calcula como el total de energía acumulada dividido entre la capacidad utilizable de la batería. El número que se muestra aquí representa el ciclo completado.",
    "status": "Estado",
    "array": "Conjunto",
    "help": "Ayuda",
    "not_reporting": "No informar",
    "not_reporting_lowercase": "no informar",
    "normal": "Normal",
    "home": "Casa",
    "no_microinverters": "No se encontró microinversor",
    "no_storage": "No se encontró almacenamiento",
    "no_envoy": "No se ha encontrado la Gateway",
    "no_enpower": "No se encontró ningún Controlador del sistema",
    "wirelessRangeExtender": "Extensor de alcance de red inalámbrica",
    "no_wirelessRangeExtender": "No se encontró ningún extensor de alcance de la red inalámbrica",
    "lastReported": "Último reportado",
    "manufacturer": "Nombre del fabricante",
    "startType": "Tipo de inicio",
    "fuelType": "Tipo de combustible",
    "modelNumber": "Número de modelo",
    "onOffCycles": "Total de ciclos de encendido y apagado",
    "maintainenceInfo": "Información de mantenimiento",
    "maintainenceSub": "Actualice estos datos para recibir notificaciones sobre el mantenimiento de su generador y las necesidades de combustible.",
    "lastMaintainenceDate": "Última fecha de mantenimiento",
    "lastRefuellingDate": "Última fecha de repostaje",
    "lastRefuellingTime": "Última hora de repostaje",
    "lastMaintainenceTime": "Última hora de mantenimiento",
    "litresOfFuel": "Liters of fuel filled",
    "additionalInfo": "Para información adicional",
    "statistics": "Sus estadísticas desde el último mantenimiento:",
    "timeElapsed": "Tiempo transcurrido:",
    "cycles": "Ciclos de encendido/apagado:",
    "runningHours": "Tiempo de funcionamiento:",
    "Days": "días",
    "update": "Actualizar",
    "clickHere": "haga clic aquí",
    "savedSuccessfully": "Su configuración se ha guardado correctamente.",
    "loads": {
      "status": "Estado",
      "smartControl": "Control inteligente",
      "auxillaryContact": "Contacto auxiliar"
    },
    "devicegenerator": {
      "on": "Encendido",
      "off": "Apagado"
    },
    "connected": {
      "true": "Conectado a la nube de Enphase",
      "false": "Desconectado de la nube de Enphase"
    },
    "envoyConnected": {
      "wait": "Buscando la Gateway...",
      "true": "Gateway detectada con éxito.",
      "false": "Gateway no detectada."
    },
    "stepOne": "Conéctese directamente a la Gateway. Para hacer esto, primero pulse el botón de conexión en la Gateway.",
    "stepTwo": "Luego diríjase a la configuración de su Wi-Fi y conéctese a la red de la Gateway:",
    "stepThree": "Una vez realizada la conexión, vuelva a esta pantalla. Se le desconectará temporalmente de Internet.",
    "connectLocally": "Conexión local",
    "connectEnvoy": "Conéctese a la Gateway usando",
    "connectEnvoyUser": "Nombre de usuario",
    "connectEnvoyPassword": "Contraseña",
    "notAllowAPMode": "La Gateway no admite una conectividad local.",
    "localEnvoyConnected": {
      "true": "Gateway detectada con éxito",
      "false": "No se ha encontrado ninguna Gateway en la red local",
      "wait": "Espere..."
    },
    "envoyPwd": {
      "urenvPwd": "Su contraseña de la Gateway",
      "retrivePwd": "Para recuperar su contraseña de la Gateway:",
      "infoTitle": "Contraseña de la Gateway",
      "infoDescription": "Necesitará esta contraseña para volver a conectar su Gateway a su Wi-Fi. Esto típicamente sucede cuando la contraseña de Wi-Fi o el proveedor de servicios han cambiado.",
      "infoLearnMore": "Clic aquí para saber más"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Encienda el Bluetooth de su teléfono para conectarse con su Puerta de enlace de IQ",
      "tryApMode": "Pruebe el modo AP",
      "gatewayNotFound": "La Puerta de enlace de IQ no es detectable. Asegúrese de que su Puerta de enlace de IQ está cerca y encendido.",
      "bleNotSupported": "Bluetooth no admitido",
      "bleNotSupportedDesc": "El Bluetooth no es admitido en su dispositivo. Asegúrese de que el dispositivo tenga las opciones de Bluetooth y Ubicación.",
      "bleConnected": "Bluetooth conectado",
      "scanningGateway": "Buscando la Puerta de enlace de IQ",
      "fewMints": "Esto puede tardar unos minutos",
      "noWifi": "Keine WLAN-Geräte gefunden	No se han encontrado dispositivos Wifi",
      "password": "Contraseña",
      "gatewayConnected": "La Puerta de enlace de IQ está conectada a la Wi-Fi con éxito.",
      "okGotIt": "Ok, entendido",
      "noGateway": "No se encuentra la Puerta de enlace de IQ",
      "gatewayNearByWarning": "Asegúrese de que su Puerta de enlace esté cerca y encendida.",
      "noNetwork": "No hay red",
      "wifiRouterWarning": "Mantenga el router Wi-Fi encendido y su Puerta de enlace de IQ en el rango Wi-Fi.",
      "connectionError": "Error de conexión",
      "turnOn": "Activar",
      "failedWifiConnect_1": "No se pudo conectar con la red Wi-Fi. Por favor ",
      "failedWifiConnect_2": "Contactar con el Servicio de Asistencia",
      "failedWifiConnect_3": " por ayuda.",
      "failedIQConnect_1": "No se pudo conectar con la Puerta de enlace de IQ. Por favor ",
      "failedIQConnect_2": "Contactar a Soporte",
      "failedIQConnect_3": " por ayuda.",
      "bleDevices": "Bluetooth-Geräte",
      "wifiNetworks": "Redes Wi-Fi",
      "connectBle": "Conéctate a Bluetooth",
      "gatewayToWifi": "Conectando Puerta de enlace IQ a Wi-Fi...",
      "bleStatus": "Comprobando estado de Bluetooth...",
      "searchingWifi": "Buscando redes Wi-Fi...",
      "connectingBle": "Conectando a Bluetooth",
      "turnOnBle": "Activar Bluetooth",
      "tryAgain": "Inténtelo de nuevo",
      "wifiSsIdConfigFailedDesc": "Se ha producido un error desconocido al conectarse a la red Wi-Fi. Inténtelo más tarde o conéctese a otra red.",
      "wifiCommunicationError": "Error de comunicación Wi-Fi",
      "wifiCommunicationErrorDesc": "No se ha podido establecer la conexión con el módulo BLE de la Puerta de enlace de IQ. Inténtelo más tarde.",
      "networkNotFound": "Red no encontrada",
      "networkNotFoundDesc": "La red a la que intenta conectarse no puede encontrarse. Asegúrese de que el router Wi-Fi está encendido o pruebe con otra red."
    }
  },
  "notification": {
    "offline": "Fuera de línea",
    "apmode": "Modo AP"
  },
  "siteempty": {
    "nosystemassociated": "Actualmente su cuenta no está asociada a ningún sistema.",
    "systemowner": "¿Es propietario de un sistema Enphase?",
    "contactyourinstaller": "Póngase en contacto con el instalador para verificar la cuenta que está asociada a su sistema.",
    "interestedonsystem": "¿Le interesaría un sistema Enphase?",
    "initiatetransferofwarranty": "Inicie la transferencia de garantía en caso de que haya comprado una propiedad con un sistema Enphase.",
    "applytransferownership": "Solicite la transferencia de propiedad aquí.",
    "ownershiptransfer": "Transferencia de propiedad",
    "visita": "Visite una",
    "publicsystempage": "página pública del sistema",
    "monitoringexperience": "para acceder a la experiencia de supervisión de Enphase."
  },
  "recaptcha": {
    "verification_failed": "Se ha producido un error durante la verificación de reCAPTCHA, vuelva a intentarlo.",
    "recaptcha_unreachable": "Ups, hemos cometido un error al validar su respuesta de reCAPTCHA. Vuelva a intentarlo."
  },
  "mobile_app_rating": {
    "enjoying_app": "¿Disfruta de la aplicación de Enphase?",
    "rate_on_play_store": "Valore su experiencia",
    "rate_on_play_store2": "En la play store",
    "rate_us": "Califícanos ahora",
    "may_be_next": "Puede ser la próxima vez"
  },
  "consumptionMtr": {
    "btnText": "Adicionar medidor de consumo",
    "infoText": "O medidor de consumo ajuda a rastrear o uso geral de energia"
  },
  "replacement": {
    "microinverter_not_reporting": "Los microinversores no generan reportes.",
    "batteryWarning": 'Esto puede ocurrir si la comunicación inalámbrica entre su puerta de enlace y la batería no es robusta. Esto puede deberse a un fallo temporal y debería recuperarse pronto. Si el problema persiste, póngase en contacto con su encargado de mantenimiento para obtener ayuda.',
    "controllerWarning": 'Esto puede ocurrir si la comunicación inalámbrica entre su puerta de enlace y el controlador del sistema no es robusta. Esto puede deberse a un fallo temporal y debería recuperarse pronto. Si el problema persiste, póngase en contacto con su encargado de mantenimiento para obtener ayuda.',
    "batteryError": 'La batería no está reportando ningún dato.',
    "controllerError": 'El Controlador del Sistema no informa.',
    "contactMaintainer": 'Póngase en contacto con su responsable de mantenimiento para obtener ayuda.',
    "systemWarning": 'advertencia del sistema',
    "array_details": "Detalles de la matriz",
    "replacement_warranty1": "Tiene",
    "replacement_warranty": "microinversores bajo garantía y disponibles para el reemplazo.",
    "shipping_address": "Dirección de envío",
    "site_address": "Dirección del lugar",
    "change": "CAMBIO",
    "select_microinverters": "SELECCIONAR MICROINVERSORES",
    "serial_number": "Buscar por número de serie",
    "status": "Estado",
    "normal": "Normal",
    "not_reporting": "Sin informar",
    "submit_request": "Enviar solicitud",
    "dear": "Estimado",
    "replacement_message1": "puede que deba contactar a su instalador",
    "replacement_message2": "para realizar el reemplazo una vez que se le envíe el dispositivo de reemplazo. Puede haber cargos por el reemplazo de su instalador.",
    "request_submitted": "Su solicitud de devolución se envió con éxito.",
    "response_message": "Use la identificación de la solicitud para realizar un seguimiento del estado del reemplazo cuando contacte al soporte.",
    "request_id": "Identificación de la solicitud",
    "ok": "Bien, lo hizo",
    "replacement_delivery": "El reemplazo se enviará a su lugar",
    "replacement_delivery_installer": "El reemplazo se enviará a su instalador local",
    "installer_address": "DIRECCIÓN DEL INSTALADOR",
    "understand": "Entiendo",
    "continue_button": "Continuar",
    "error_message": "No se generó la ID de la solicitud.",
    "failed_to_fetch": "No se pudieron recuperar microinversores. Inténtelo de nuevo",
    "change_address": "Cambiar dirección de envío"
  },
  "tariff": {
    "tariff": "Arancel",
    "tariffNotAdded": "No se agregó la tarifa",
    "tariffNotSet": "No se estableció la tarifa",
    "tariffType": "Tipo de tarifa",
    "buying": "Comprar",
    "selling": "Vender",
    "flat": "Tarifa fija",
    "tou": "Tiempo de uso",
    "tiered": "Categoría",
    "copyFromBuyingTariff": "Copiar de la tarifa de compra",
    "copyFromSellingTariff": "Copiar de la tarifa de venta",
    "dayBasedTariff": "¿Su tarifa varía durante el día?",
    "unitsBasedTariff": "¿Su tarifa varía de acuerdo a las unidades consumidas?",
    "seasonalTariff": "¿Su tarifa varía según la temporada?",
    "weekendTariff": "¿Su tarifa varía los fines de semana?",
    "baseRateTariff": "Cuál es la tarifa base?",
    "flatLabel": "El costo de la energía se fija durante el día.",
    "touLabel": "El costo de la energía varía durante las horas pico.",
    "tieredLabel": "El costo de la energía varía a medida que aumenta el consumo por unidad.",
    "rate": "Precio",
    "addSeason": "Agregar estación del año",
    "season": "Estación del año",
    "next": "Siguiente",
    "noSeasonWeekend": "La tarifa no varía con la estación del año ni los fines de semana.",
    "weekendOnly": "La tarifa varía solo los fines de semana.",
    "seasonAndWeekend": "La tarifa varía con la estación del año y los fines de semana.",
    "seasonOnly": "La tarifa varía solo con la estación del año.",
    "infoText": "Informacion",
    "baseRate": "Precio de referencia",
    "remove": "Eliminar",
    "from": "Desde",
    "to": "Hasta",
    "addPeak": "Agregar pico",
    "tariffDetails": "Los detalles de tarifa",
    "off-peak": "Off-Peak",
    "above": "Sobre",
    "below": "Debajo",
    "between": "Entre",
    "and": "y ",
    "weekdays": "días de semana",
    "weekend": "fin de semana",
    "winter": "Invierno",
    "summer": "Verano",
    "fall": "Otoño",
    "spring": "Primavera",
    "confirmAndSave": "Confirmar y guardar",
    "buyingTariff": "Comprando tarifa",
    "sellingTariff": "Vendiendo tarifa",
    "edit": "Editar",
    "offPeak": "Fuera de las horas pico",
    "peak": "En horas pico",
    "period": "En horas pico",
    "addTier": "Agregar categoría",
    "tier": "Categoría",
    "yesLabel": "si",
    "noLabel": "No",
    "manualConfiguration": "Configuraciones manuales",
    "added": "agregado",
    "modified": "modificado",
    "successfully": "con éxito",
    "alreadySelected": "ya está seleccionado",
    "alreadyAdded": "ya está agregado",
    "buyingTariffAdded": "Comprar la tarifa se agregó con éxito",
    "sellingTariffAdded": "Vender la tarifa se agregó con éxito",
    "buyingTariffModified": "Comprar la tarifa se modificó con éxito",
    "sellingTariffModified": "Vender la tarifa se modificó con éxito",
    "buyingTariffReset": "Comprar la tarifa se reestableció con éxito",
    "sellingTariffReset": "Vender la tarifa se reestableció con éxito",
    "reset": "Reestablecer",
    "resetConfirmationText": "¿Está seguro que desea reestablecer los detalles de tarifa?",
    "resetErrorText": "No se puede reestablecer los detalles de tarifa",
    "updateErrorText": "No se puede actualizar los detalles de tarifa",
    "tariffErrorText": "Entrada no válida. Este valor ya existe en Categoría ",
    "tierInvalidEntry": "Acceso no válido. El valor debe ser mayor a \"Categoría 1\"",
    "timeInvalidEntry": "Acceso no válido. El valor debe ser mayor a \"Desde\"",
    "invalidValue": "Valor debe ser mayor a 0"
  },
  "currency": {
    "currencyEquivalent": "Vea la moneda equivalente de los valores energéticos",
    "currencyConversion": "Establezca el factor de conversión de moneda",
    "currencyInfo": "El valor monetario informado es una estimación promedio ya que no tiene en cuenta los precios de impuestos, tarifas, categoría, demanda o tiempo de uso.",
    "currencyFactor": "Factor de conversión de moneda",
    "currencyFactorSubtitle": "Los datos energéticos se convierten en el valor de su moneda equivalente al multiplicarlos por el factor de conversión de moneda.",
    "currencyNote": "Nota: El valor monetario informado es una estimación promedio ya que no tiene en cuenta los precios de impuestos, tarifas, categoría, demanda o tiempo de uso.",
    "conversionFactor": "Factor de conversión",
    "currencyEquivalentHeader": "Moneda equivalente",
    "energyImported": "Energía importada",
    "energyExported": "Energía exportada",
    "netEnergyImported": "Energía importada neta",
    "netEnergyExported": "Energía exportada neta",
    "currencyConversionHeader": "Conversión de moneda",
    "confirmationMessage": "¿Desea continuar sin guardar los cambios?",
    "confirmationYes": "Sí",
    "confirmationNo": "No",
    "invalidInput": "Entrada inválida"
  },
  "demo": {
    "appDemo": "Demo de aplicación",
    "message": "Esta es una aplicación de demostración",
    "enphaseInstaller": "Instalador de Enphase",
    "mainHeader": "Sistema de energía inteligente todo en uno",
    "subHeader": "Obtenga energía solar y el almacenamiento",
    "getStarted": "Empezar",
    "appDemoDesc": "Toque para ver cómo funciona un sistema",
    "loginDesc": "Para usuarios registrados",
    "selectLanguage": "Seleccionar idioma"
  },
  "connectionBandwidth": {
    "low": "Ancho de banda bajo. Reporta datos cada 6 horas",
    "high": "Ancho de banda estándar. Reporta datos cada 15 minutos"
  },
  "release_notes": {
    "appUpdateHeading": "Nueva actualización para su aplicación de Enphase",
    "appUpdateSuccessHeading": "Su aplicación de Enphase se ha actualizado",
    "later": "Más tarde",
    "updateNow": "Actualizar ahora",
    "update": "Actualizar",
    "whatsNew": "Esto es lo nuevo",
    "askWhatsNew": "¿Qué hay de nuevo?",
    "new": "Nuevo",
    "version": "Versión",
    "readMore": "Continúe leyendo"
  },
  "storageCapacity": {
    "availableEnergy": "Energía disponible",
    "totalStorage": "Almacenamiento total",
    "encharge": "IQ Battery",
    "acBattery": "Baterías CA.",
    "of": "de",
    "availablePower": "Potencia disponible",
    "activeMicroinverters": "Microinversor(es) activo(s)",
    "activeEncharge": "Activar la(s) baterías(s)",
    "microinverters": "Microinversores"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Cargue una imagen del sitio de su elección",
    "selectImage": "Seleccionar Imagen",
    "imageSizeError": "*El tamaño de la imagen debe ser inferior a 5 MB",
    "hide": "Ocultar",
    "apply": "Aplicar",
    "hideSiteImage": "Ocultar imagen del sitio",
    "hideSiteImageDesc1": "La imagen del sitio no se mostrará en la página de estado. Puede cambiar la preferencia yendo a Menú -> Sistema -> Detalles del sitio.",
    "hideSiteImageDesc2": "Quieres proceder?",
    "uploadSuccessToast": "La imagen de su sitio se actualizó con éxito",
    "maxImageLimit": "Puede cargar hasta cuatro imágenes para su sitio. Por favor, elimine una imagen para agregar una nueva.",
    "okGotIt": "Ok, entendido",
    "imageSIzeErrorSiteDetails": "El tamaño de la imagen debe ser inferior a 5 MB. Sube una imagen diferente.",
    "apiError": "No se puede completar la solicitud. Por favor, inténtelo de nuevo más tarde",
    "displayOnStatusPage": "Mostrar en la página de estado",
    "displayOnStatusPageWarning": "¿Está seguro de que desea actualizar la imagen en la página de estado?",
    "displayOnStatusPageNote": "Nota: La imagen se ajustará automáticamente para mostrarse. Siempre puede reajustarlo en la página Estado",
    "deleteSiteImage": "Eliminar Imagen",
    "deleteSiteImageWarning": "¿Está seguro de que desea eliminar la imagen?",
    "imageDeleteSuccess": "La imagen se eliminó con éxito",
    "imageUploadSuccess": "La imagen se cargó con éxito",
    "imageUploadSuccessStatusPage": "Imagen actualizada con éxito en la página de estado",
    "displayedOnStatusPage": "Mostrado en la página de estado",
    "uploadImage": "Cargar imagen",
    "imagePreferenceSaved": "Se guarda la preferencia de imagen de su sitio",
    "siteImage": "Imagen del sitio",
    "statusPageMaxImagePopUpDesc1": "Puede cargar hasta cuatro imágenes para su sitio. Elimine una imagen de ",
    "statusPageMaxImagePopUpDesc2": " para agregar una nueva aquí",
    "addSiteImage": "AGREGAR IMAGEN DEL SITIO",
    "wrongFileType": "Cargue solo una imagen JPEG o PNG"
  },
  "nps": {
    "question": "¿Cómo es su experiencia con nosotros?",
    "description": "De acuerdo a su última experiencia con Enphase, ¿qué posibilidades hay de que recomiende Enphase a un amigo o a un colega?",
    "dontAskAgain": "No volver a preguntar",
    "notNow": "No ahora",
    "notLikely": "No es probable",
    "mostLikely": "Más probable",
    "confirmationHeader": "¡Gracias por su respuesta! Ayúdenos a comprender mejor su respuesta.",
    "surveyButton": "Realice una encuesta de 2 minutos",
    "notInterested": "No estoy interesado",
    "survey": "Evaluación",
    "internetError": "Verifique su conexión a internet y vuelva a intentar.",
    "rateEnphaseTitle": "Clasifique a Enphase",
    "rateEnphaseDescription": "¿Qué posibilidades hay de que recomiende Enphase a un amigo o a un colega?",
    "rateInstallerTitle": "Clasifique a su instalador",
    "rateInstallerDescription1": "¿Qué posibilidades hay de que recomiende",
    "rateInstallerDescription2": "a un amigo o a un colega?",
    "feedbackSuccess": "Gracias por sus valiosos comentarios.",
    "ratingSuccess": "Gracias por tus comentarios.",
    "feedbackEnphaseTitle": "Tu calificación de Enphase",
    "feedbackInstallerTitle": "Su calificación de instalador",
    "detractors": "¿Qué podríamos estar haciendo mejor?",
    "passive": "¿Qué podemos hacer para mejorar tu experiencia?",
    "promoters": "Ayúdanos explicando tu puntaje?",
    "legalDisclaimer": "Su nombre y retroalimentación/comentarios serán compartidos con los instaladores."
  },
  "liveStatus": {
    "title": "En tiempo real",
    "subTitle": "Ver potencia en tiempo real",
    "offlineMsg": "Use LIVE STATUS when Offline",
    "streamingLocally": "Transmitiendo a nivel local desde la Gateway",
    "closingMinutes": "Cerrando",
    "cfgMsg": "Las baterías podrían cargarse desde la red ya que ha activado el ajuste %{cfglink}.",
    "learn": "Aprender",
    "pvOnlyCta": "%{learn} cómo puede optimizar y controlar su uso de la energía mediante la medición del consumo",
    "cfgFiller": "Cargue la batería de la red",
    "cfgVls": "Las baterías podrían cargarse desde la red ya que la carga de su batería está por debajo del nivel de apagado.",
    "solar": {
      "title": "Solar",
      "producing": "Produciendo",
      "energyProducing": "Produciendo energía"
    },
    "home": {
      "title": "Inicio",
      "consuming": "Consumiendo",
      "energyConsuming": "Consumiendo energía"
    },
    "grid": {
      "title": "Red",
      "gridConnectivity": "Conexión a la red",
      "waiting": "En attente d’informations",
      "unknown": "Estado de la red desconocido",
      "notAvailable": "La red no está disponible",
      "systemConnected": "El sistema está en Red",
      "notSystemConnected": "El sistema no está en Red",
      "outage": "Grid Outage",
      "updating": "Actualizando el Estado de red",
      "exporting": "Exportando",
      "importing": "Importando",
      "notConnected": "No está conectado",
      "offGrid": "Desconectado de la Red (Off)",
      "onGrid": "Conectado a la Red (On)",
      "goOnGrid": "Entrar a la red",
      "goOffGridDisabled": "No se permite la desconexión de la red",
      "goOffGrid": "Salir de la red",
      "gridUpdatingMessage": "La confirmación del estado de la red tarda más de lo esperado. Por favor, regrese más tarde.",
      "gridConnectedMessage": "su sistema ahora está conectado a la red",
      "gridDisconnectedMessage": "su sistema ahora está desconectado de la red",
      "disconnectingGrid": "Desconectando de la Red...",
      "connectingGrid": "Conectando a la Red...",
      "unableToConnect": "No se ha podido conectar con la Gateway",
      "initialisingOnGrid": "Inicializando el Control de red...",
      "gridOutage": "El sistema está Fuera de red debido a un corte de la red",
      "gridOutageToastAuto": "No puede conectarse a la red debido a un corte de energía. Cuando se restablezca el suministro eléctrico, el sistema volverá a conectarse a la red",
      "gridOutageToastUser": "No puede conectarse a la red debido a un corte de energía. Puede controlar la conexión a la red una vez que la red de suministro esté disponible"
    },
    "generator": {
      "title": "Générateur",
      "onGenerator": "Generador encendido",
      "offGenerator": "Generador apagado",
      "unknown": "Estado del generador desconocido",
      "notConnected": "No está conectado",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Actualizando",
      "updating": "Hacer el pedido ahora"
    },
    "fuelCell": {
      "title": "Célula de combustible",
      "on": "Célula de combustible encendida",
      "off": "Célula de combustible apagada",
      "warmingUp": "Calentamiento de la célula de combustible",
      "coolDown": "Enfriamiento de la célula de combustible",
      "unknown": "Estado de la célula de combustible desconocido",
      "notConnected": "No conectado",
      "genDisconnecting": "Desconectando...",
      "waiting": "Esperando",
      "updating": "Actualizando"
    },
    "systemNotReporting": {
      "title": "El Controlador del Sistema no informa",
      "subTitle": "No podemos mostrar los datos en directo porque el controlador de su sistema no está informando a la puerta de enlace. Esto puede deberse a un fallo temporal y debería recuperarse pronto."
    },
    "envoy": {
      "connecting": "Conectando a la Gateway...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "No se puede conectar",
      "notAbleToConnectMultiEnv": "No se puede conectar a la puerta de enlace SN:",
      "negativeConsumptionTitle": "Error de comunicación",
      "negativeConsumptionDesc": "No podemos mostrar el estado completo en vivo debido a la pérdida de comunicación entre sus dispositivos. Se trata de un fallo temporal y debería recuperarse pronto."
    },
    "onDifferentNetwork": "Su Gateway y este dispositivo están en redes diferentes",
    "connectOnSameNetworkorAPMode": "Conecte su Gateway y el dispositivo a la misma red o active el modo AP de la Gateway para conectar este dispositivo a la red Wi-Fi %{ssid}​",
    "connectOnSameNetwork": "Conecte este dispositivo a la red Wi-Fi %{ssid} y vuelva a ver el estado en tiempo real en modo Fuera de línea.",
    "apModeTutorial": "Tutorial del modo AP",
    "apMT1": "Pulse y suelte (no mantenga pulsado) el ",
    "apMT2": "Botón de Modo AP",
    "apMT3": " hasta que el LED de Modo AP (",
    "apMT4": ") se enciende con luz verde fija. La Gateway permanecerá en Modo AP por ocho horas."
  },
  "desktop": {
    "status": {
      "power": "Potencia",
      "energy": "Energía",
      "solarEquivalent": "Equivalente a energía solar",
      "dataUnavailable": "Los datos no están disponibles"
    },
    "array": {
      "title": "Formación",
      "totalProduced": "Producción total",
      "totalConsumed": "Consumo total",
      "lifetimeProduced": "Producido con vida útil",
      "lifetimeConsumed": "Vida útil consumida",
      "status": "Estado",
      "azimuth": "Azimut",
      "tilt": "Inclinación",
      "microinverter": "Microinversor"
    },
    "energy": {
      "totalEnergy": "Energía total",
      "graphControls": "Controles de gráfico"
    },
    "header": {
      "switchToClassic": "Cambiar a vista clásica"
    },
    "footer": {
      "change": "Cambiar",
      "changeSite": "modificar el lugar",
      "copyRightsText": "©2008-%{currYear} Enphase Energy Inc. Todos los derechos reservados.",
      "privacyText": "Privacidad",
      "termsText": "Términos",
      "weatherCompany": "The Weather Company",
      "weatherDataText": "Datos meteorológicos suministrados por"
    }
  },
  "customPeriod": {
    "dialogLabel": "Vista basada en",
    "billingCycle": "Ciclo de facturación",
    "billingLabel": "Haga coincidir el gráfico de energía con su ciclo de facturación",
    "billingLabelStatusPage": "Rango de tiempo desde cualquier fecha de inicio seleccionada para la duración seleccionada",
    "startDate": "Fecha de inicio de facturación",
    "frequency": "Frecuencia de facturación",
    "months": "Meses",
    "days": "Días",
    "every": "Cada",
    "customDate": "Rango de fechas personalizado",
    "customDateLabel": "Seleccione un periodo de fechas personalizado para verlo en el gráfico de energía",
    "customRange": "Seleccione un rango de fechas de 1 a 100 días"
  },
  "systemEstimator": {
    "heading": "Calculadora del sistema",
    "exitConfirmation": "¿Está seguro de que desea cerrar el flujo Agregar almacenamiento?",
    "resumeButton": "Reanudar",
    "systemAccess": "Obtenga acceso al sistema",
    "statusAddStorage": "to avoid blackouts",
    "addStorageLeadInfo": "ver estado",
    "postLoginWoSiteTitle": "Conozca el único sistema de almacenamiento y energía solar todo en uno",
    "videoCTABtn": "Ver video",
    "addStorageTitle": "Obtenga un nuevo sistema Enphase",
    "orderNowBtn": "Ordenar ahora"
  },
  "sgipIncentive": {
    "gotItButton": "Entendido",
    "exitButton": "Salir",
    "dontExitButton": "No salir",
    "sgipPaymentNotDone": "Su solicitud de SGIP está incompleta. ¿Quiere salir sin completar su solicitud?",
    "sgipPaymentDone": "Puede regresar en cualquier momento para verificar el estado de su solicitud SGIP",
    "sgipApplyAlert": "Los incentivos del SGIP se aplican a sistemas instalados exclusivamente en California. Si ya tiene una activación del sistema en curso en California, pídale a su instalador que inicie el proceso de creación del sitio en su aplicación de Enphase.",
    "sgipGetStorage": "Obtenga un nuevo sistema de almacenamiento Enphase"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "El estado de la cuadrícula cambió a",
    "gridOn": "En la red",
    "gridOff": "Fuera de la red",
    "batteryChangeDesc": "Perfil de batería cambiado a",
    "costSavings": "Ahorro de costes",
    "selfConsumption": "Autoconsumo",
    "savingsMode": "Modo de ahorro",
    "backupOnly": "Solo respaldo",
    "stormGuardDesc": "Protección de tormena es",
    "alertIssued": " alerta emitida",
    "alertHasEnded": " la alerta ha finalizado"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normal",
    "unknown": "Desconocido",
    "undefined": "Indefinido",
    "loads": "Control de la carga",
    "loadsInfoPart1": "El instalador asigna la carga a ",
    "loadsInfoPart2": "Contactos auxiliares del Controlador del sistema",
    "loadsInfoPart3": " Puedes configurar estas cargas en ",
    "loadsInfoPart4": "Configuración del sistema.",
    "powered": "Alimentado",
    "invalidState": "Estado Inválido",
    "viewMore": "Ver más",
    "viewLess": "Ver menos",
    "ECA_BAT_IDLE": "Inactivo",
    "ECA_BAT_CHARGING": "Cargando",
    "ECA_BAT_DISCHARGING": "Descargando",
    "MAX_ECA_BAT_STATE": "Desconocido",
    "systemIsOnGrid": "El sistema está en Red",
    "systemIsOffGrid": "El sistema no está en Red",
    "infoIsOnGrid": "El sistema está funcionando en modo conectado a la red.",
    "infoIsOffGrid": "El sistema está funcionando en modo microred.",
    "wiredCANConn": "Conexión CAN por cable",
    "infoWiredCAN": "El Controlador del Sistema IQ se comunica con el IQ de la Puerta de enlace a través de una conexión por cable. El icono representa si está o no conectado y comunicándose con la Puerta de enlace.",
    "infoIsOffGridAvailable": "El sistema está funcio'nando en modo microred. Sin embargo, la red está disponible y puede elegir conectarse a la Red en cualquier momento.",
    "voltageL1": {
      "val": "Voltaje L1",
      "info": "El voltaje entre la Línea 1 (L1) y el Neutro."
    },
    "voltageL2": {
      "val": "Voltaje L2",
      "info": "El voltaje entre la Línea 2 (L2) y el Neutro."
    },
    "voltageL3": {
      "val": "Voltaje L3",
      "info": "El voltaje entre la Línea 3 (L3) y el Neutro."
    },
    "voltage": {
      "val": "Voltaje",
      "info": "El voltaje entre la Línea 1 (L1) y el Neutro."
    },
    "frequency": {
      "val": "Frecuencia",
      "info": "La Frecuencia nominal de corriente alterna (CA)."
    },
    "gridParameters": "Parámetros de la red pública",
    "auxiliaryContactsParameters": "Control de la carga",
    "infoauxiliaryContactsParam": "El Controlador del sistema tiene cuatro contactos auxiliares para el control de carga. El nombre de carga indica que el contacto correspondiente está mapeado a esa carga. Para los contactos no mapeados a ninguna carga, se mostrará “Sin usar”.",
    "infoGridParam": "El voltaje y la frecuencia de la red se miden en el lado de la red eléctrica del Dispositivo de interconexión de la microred (MID). Cuando la red no está disponible, el voltaje y la frecuencia de la red son 0.",
    "microgridParameters": "Parámetros de microred",
    "infoMicrogridParam": "El voltaje y la frecuencia de la microred se miden en el lado de la carga del Dispositivo de interconexión de la microred (MID). Si su MID está abierto, entonces su sistema está en el modo Fuera de Red/Microred.",
    "generatorParameters": "Parámetros del generador",
    "infoGeneratorParam": "El voltaje y la frecuencia del generador se miden en el lado de la carga del Dispositivo de interconexión de la microred (GID). Si su Dispositivo de interconexión de la microred (GID) está cerrado, entonces su sistema está en el modo Fuera de Red/Microred.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Señal de comunicación",
    "infoZigbeeSignal": "Representa la intensidad de la comunicación inalámbrica de 2,4 GHz con la Gateway. Más barras o un valor de dBm más alto representa una intensidad de señal más fuerte.",
    "commStatus": "Estado de la comunicación",
    "infoCommSignal": "SEÑAL DE COMUNICACIÓN",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "IQ System Controller se comunica con IQ Gateway a través de una conexión USB. El icono representa si el USB está conectado y se comunica con IQ Gateway.",
    "commStatusDesc": "IQ Battery se comunica con IQ System Controller a través de una conexión por cable. El icono representa si IQ Battery está conectado y se comunica con IQ System Controller.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Desconocido"
    },
    "ENCMN_STATE_MISSING": {
      "val": "Fallo de comunicación de 2,4 GHz"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "2.4 GHz pairing"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "Emparejamiento de 2,4 GHz completo"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Recuperación de la información del dispositivo finalizada"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "Esperando que las baterías reconozcan el estado de la red"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Ordenar al Controlador del sistema cerrar el relé EC1."
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Desconocido"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Iniciando actualización de perfil de red"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Actualización del perfil de red en curso"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Actualización del perfil de red finalizada"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Mostrar los estados de relé del Controlador del sistema después de la inicialización"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Interpretar los estados del relé del Controlador del sistema"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "El Controlador del sistema está en modo de autonomía de la red eléctrica"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "El Controlador del sistema está en modo de autonomía de la red eléctrica. La red está disponible"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "La microred está sincronizada con la red. Listo para conectarse a la Red"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "El Controlador del sistema está en modo de conexión a la red"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Ordenar al Controlador del sistema conectarse a la red."
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Preparándose para ejecutar el comando del usuario para salir de la Red"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Ordenar al Controlador del sistema desconectarse de la red."
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "El controlador del sistema está En red. Detectando baterías."
    },
    "ENCMN_STATE_MAX": {
      "val": "Desconocido"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "No micros detected"
    },
    "ENCHG_STATE_READY": {
      "val": "La batería está funcionando"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Enviando el modo de red a la batería"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Actualizar el límite del estado de carga (SoC) de reserva en la batería"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Iniciando actualización de perfil de red"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Actualización del perfil de red en curso"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Actualización del perfil de red finalizada"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Recuperar la información del hardware y software de la baterías"
    },
    "ST_NOP": {
      "val": "Desconocido"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "El Controlador del sistema está en modo de autonomía de la red eléctrica. Conectando al generador."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "El Controlador del sistema está en modo de autonomía de la red eléctrica. Generador conectado."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "El Controlador del sistema está en modo de autonomía de la red eléctrica. Desconectando generador."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 cerrado. Prueba de relé completa."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 abierto. Prueba de relé en curso."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "Relé GEN cerrado. Prueba de relé completa."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "Relé GEN abierto. Prueba de relé en curso."
    },
    "default": {
      "val": "Desconocido"
    },
    "controlState": "Estado de control",
    "CHECK_BUSES": {
      "val": "Comprobación de buses y relés",
      "info": "Se restableció el Controlador del sistema. Validar los parámetros del sistema antes de hacer la transición a un estado de red diferente."
    },
    "CYCLE_RELAYS": {
      "val": "Relés en ejecución",
      "info": "El sistema está activando los relés del Controlador del sistema para validar si las condiciones de errores de relé se han solucionado."
    },
    "GRID_CONNECT": {
      "val": "Conectándose a la Red",
      "info": "El sistema está conectándose a la red después de que se ha restablecido el Controlador del sistema."
    },
    "EC1_EC2_CONNECT": {
      "val": "Baterías conectadas. Conectando a NFT",
      "info": "El sistema está haciendo la transición a microrred. Las baterías están conectadas. El Transformador formador de neutro (NFT) se está conectando."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "Conectado a la red. Conectando las baterías",
      "info": "El sistema está en modo de conexión a la red. Las baterías están en el proceso de conectarse."
    },
    "GRID_OP_FULL": {
      "val": "En red",
      "info": "Su sistema está funcionando en modo conectado a la red."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Fuera de red",
      "info": "Su sistema está funcionando en modo de microred."
    },
    "SYNC_TO_GRID": {
      "val": "Sincronizando con la Red",
      "info": "Su sistema está pasando de microred a En red."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Fallo de la microred",
      "info": "La microred colapsó debido a una sobrecarga o un error del sistema. El sistema se recuperará pronto."
    },
    "MANUFACTURING_MODE": {
      "val": "Modo de fabricación",
      "info": "Comuníquese con el servicio de atención al cliente."
    },
    "RESET": {
      "val": "Restablecimiento del Controlador del sistema",
      "info": "Su Controlador del sistema se ha restablecido. El sistema se recuperará pronto."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "En red. Abriendo NFT",
      "info": "Su sistema está en Red. El Transformador de formación de neutro (NFT) está siendo desconectando."
    },
    "MANUAL_OVERRIDE": {
      "val": "Anulación manual activada",
      "info": "Ha cerrado manualmente el Dispositivo de interconexión de la microred (MID) para conectarse a la Red. Llame al servicio de atención al cliente si no lo hizo intencionalmente. "
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Desconocido",
      "info": "Comuníquese con el servicio de atención al cliente."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Sincronizado y conectándose a la Red"
    },
    "infoControlState": "Estados de control",
    "faults": "Error del Controlador del sistema",
    "MID_FUSED": "Su sistema no puede pasar al modo de microred ya que el MID está atascado en cerrado.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Los relés del Transformador de formación de neutro (NFT) están atascados en cerrados.",
    "NFT_OPEN": "Su sistema no puede pasar al modo de microred porque los relés del Transformador de formación de neutro (NFT) están atascados en abierto.",
    "MID_OPEN": "Su sistema no puede pasar al modo conectado a la red ya que el MID está atascado en abierto.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Su sistema no está en funcionamiento. El Panel del Interruptor de transferencia automática (ATS) del Controlador del sistema ha fallado.",
    "ADC_INIT": "Su sistema no está en funcionamiento. El Panel del Interruptor de transferencia automática (ATS) del Controlador del sistema ha fallado.",
    "I2C_COMM": "Su sistema no está en funcionamiento. El Panel del Interruptor de transferencia automática (ATS) del Controlador del sistema ha fallado.",
    "NFT_TEMP": "El sistema no está en funcionamiento. El Transformador formador de neutro (NFT) ha excedido los límites de temperatura.",
    "ATS_TEMP": "El sistema no está en funcionamiento. El Panel del Interruptor de transferencia automática (ATS) del Controlador del sistema ha excedido los límites de temperatura.",
    "E3_TEMP": "El sistema no está en funcionamiento. El Panel del Controlador del sistema ha excedido los límites de temperatura.",
    "CRC_MISMATCH": "El sistema no está en funcionamiento. El Panel del Controlador del sistema no pudo iniciarse.",
    "V_IMBALANCE": "Su sistema no puede pasar al modo de microred. Un desequilibrio de voltaje entre L1 y L2 ha provocado un disparo.",
    "MANUAL_OVR": "El sistema está en el modo de conexión a la red debido a la anulación manual del Controlador del sistema",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "El Dispositivo de interconexión de la microred (MID) conecta (cuando está cerrado) o desconecta (cuando está abierto) su vivienda de la red pública."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Los relés de recursos energéticos distribuidos (DER) DER L1 cuando están cerrados conectan sus Encharges y sistemas fotovoltaicos en la línea 1 o 2 respectivamente a su Vivienda"
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "SRT_L1_L2": {
      "val": "SRT L1_L2"
    },
    "SRT_L1_L3": {
      "val": "SRT L1_L2"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "Los relés L1 y L2 de EC1 cuando están cerrados conectan sus baterías o el sistema fotovoltaico IQ8 PV a las cargas de su hogar. Funcionan de línea a línea y no tienen neutro."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "Los relés IQ Battery L1 y L2, cuando están cerrados, conectan sus baterías a las cargas de su hogar. Operan línea a línea y no tienen neutro."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "Cuando los relés L1 y L2 fotovoltáicos se cierran, conectan tu IQ8 FV a las cargas de tu hogar. Funcionan de línea a línea y no tienen neutro."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "Cuando los relés L1 y L2 fotovoltáicos se cierran, conectan tu IQ FV a las cargas de tu hogar. Funcionan de línea a línea y no tienen neutro."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "NFT es el Transformador de formación de neutro. Garantiza que su sistema pueda funcionar en modo Fuera de la red. El relé NFT L1 cuando está cerrado enciende su NFT. El relé NFT N cuando está cerrado conecta el neutro de NFT a las cargas de su vivienda."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "Los relés GID L1 y L2 conectan su Generador a las cargas de su vivienda cuando están cerrados."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "NFT es el Transformador de formación de neutro. Garantiza que su sistema pueda funcionar en modo Fuera de la red. El relé NFT L2 cuando está cerrado enciende su NFT. El relé NFT N cuando está cerrado conecta el neutro de NFT a las cargas de su vivienda."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "Los relés L1 y L2 de DER1, cuando están cerrados, conectan sus baterías o el sistema fotovoltaico IQ8 a sus cargas del hogar. Funcionan de línea a línea y no tienen neutro."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "Los relés DER2 L1 y L2 conectan su IQ8 PV a las cargas de su vivienda cuando están cerrados. Las cargas operan de línea a línea y no tienen un neutro."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Estos relés, cuando están cerrados, conectan sus cargas a la fuente de alimentación"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Los relés DER L1, DER L2, DER L3 y DER N de los Recursos Energéticos Distribuidos (DER, Distributed Energy Resource) cuando están cerrados conectan su Batería IQ y su Microinversor IQ en la línea 1, 2, 3 y a Neutro respectivamente para su Vivienda."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Los relés DER L1, DER L2 y DER N de los Recursos Energéticos Distribuidos (DER, Distributed Energy Resource) cuando están cerrados conectan su Batería IQ y su Microinversor IQ en la línea 1, 2, 3 y a Neutro respectivamente para su Vivienda."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Los relés DER L1 y DER N de los Recursos Energéticos Distribuidos (DER, Distributed Energy Resource) cuando están cerrados conectan su Batería IQ y su Microinversor IQ en la línea y a Neutro respectivamente para su Vivienda."
    },
    "open": "Abierto",
    "closed": "Cerrado"
  }, _defineProperty(_liveVitalStats, "powered", "Alimentado"), _defineProperty(_liveVitalStats, "notPowered", "No alimentado"), _defineProperty(_liveVitalStats, "niu", "Sin usar"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "Se observa la diferencia entre el voltaje y la frecuencia de la Red pública y la Microred debido a la caída de voltaje en el Dispositivo de interconexión de la microred (MID)."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "El diagrama de bloques del Controlador del sistema es solo a efectos ilustrativos."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Relés del Controlador del sistema"), _defineProperty(_liveVitalStats, "bmuWarning", "Advertencia de BMU"), _defineProperty(_liveVitalStats, "bmuL1Error", "Error de nivel 1 de BMU"), _defineProperty(_liveVitalStats, "bmuL2Error", "Error de nivel 2 de BMU"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Advertencia de voltaje máximo de celda de batería"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Advertencia de voltaje mínimo de celda de batería"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Advertencia de desequilibrio de voltaje de celda de batería"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Advertencia de voltaje excesivo del interruptor FET de la batería"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Nivel de error de voltaje máximo de celda de batería 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Nivel de error de voltaje mínimo de celda de batería 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Nivel de error de temperatura máxima de celda de batería 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Nivel de error de temperatura mínima de celda de batería 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Nivel de error de descarga de sobrecorriente 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "No hay comunicaciones de BMU."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Nivel de error de corriente del transistor de efecto de campo 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Nivel de error de fusible abierto 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Nivel de error del controlador del transistor de efecto de campo 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Nivel de error de línea de detección de voltaje abierta 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Nivel de error de sobretemperatura de transitor de efecto de campo 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Nivel de error de línea térmica abierta 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Nivel de error de circuito de precarga de 24 V 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Nivel de error de voltaje de celda de batería de precarga"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Nivel de error de voltaje máximo de celda de batería 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Nivel de error de voltaje mínimo de celda de batería 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Nivel de error de temperatura máxima de celda de batería 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Nivel de error de temperatura mínima de celda de batería 2"), _defineProperty(_liveVitalStats, "gridMode", "Modo de Red"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Conectado a la red",
    "info": "La batería está en el modo de conexión a la red. En este estado temporal no formará una microrred cuando la red no está disponible.",
    "pcuInfo": "El microinversor está en modo conectado a la red. No formará una microred cuando la red no esté disponible."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "En red",
    "info": "La batería está en el modo de conexión a la red y es capaz de formar una microrred cuando lo necesita.",
    "pcuInfo": "El microinversor está en modo conectado a la red y es capaz de formar una microred cuando sea necesario."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Fuera de red",
    "info": "La batería ha formado una microrred.",
    "pcuInfo": "El microinversor ha formado una microred."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Isla detectada",
    "info": "La batería ha detectado que la red es inestable/no está disponible. Está en el proceso de formar la microrred.",
    "pcuInfo": "El microinversor ha detectado que la red es inestable/no está disponible. Está en proceso de formación de la microred."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Formación de microred",
    "info": "La batería acaba de reiniciarse. Ha detectado que la red pública no está disponible y está en el proceso de formar la microrred. Reducir la carga del hogar ayuda a la formación de la microrred.",
    "pcuInfo": "El microinversor se acaba de reiniciar. Ha detectado que la red pública no está disponible y está en proceso de formar la microred. La reducción de la carga doméstica ayuda a la formación de microredes."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Inválido",
    "info": "Modo de red inválido recibido para la batería.",
    "pcuInfo": "Se recibió un modo de red no válido para el microinversor."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "Modos de red"), _defineProperty(_liveVitalStats, "ledStatus", "Estado de LED"), _defineProperty(_liveVitalStats, "phase", "Fase"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "En cada batería hay %{pcuLength} microinversores IQ8X-BAT."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Un valor positivo de potencia del microinversor (kW) indica que la batería se está descargando, mientras que un valor negativo de potencia (kW) indica que la batería se está cargando."), _defineProperty(_liveVitalStats, "infoPcuMicro", "Microinversores IQ8X-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "Microinversores IQ8D-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "En cada batería hay %{pcuLength} microinversores IQ8D-BAT."), _defineProperty(_liveVitalStats, "pcu", "Micro"), _defineProperty(_liveVitalStats, "enph_oper_state", "Estado"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Inactivo"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "Comenzando"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Detección mediante Comunicación por línea eléctrica (PLC) en curso"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normal (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normal (irrupción)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Funcionamiento en modo de voltaje CC constante"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normal (en espera)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Apagado (falla de protección)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Apagado (falla de la red)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normal (comprobación DCR)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Desconocido"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Fallo de firmware"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Deshabilitado (apagado del servidor)"
  }), _defineProperty(_liveVitalStats, "ac_power", "Alimentación de CA"), _defineProperty(_liveVitalStats, "signalStrength", "Intensidad de la 'señal"), _defineProperty(_liveVitalStats, "commOk", "Com Ok"), _defineProperty(_liveVitalStats, "noComm", "Sin comunicación"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Desconocido"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "Estado de LED",
    "code": {
      "-1": "Desconocido",
      "0": "Error que requiere de reparación",
      "1": "Error de BMU L1",
      "2": "Alta temperatura",
      "3": "Interruptor de CC apagado",
      "4": "No hay comunicación con la Gateway",
      "5": "Comunicaciones conectadas pero no desafiadas",
      "6": "Comunicaciones conectadas y desafiadas",
      "7": "Error de actualización",
      "8": "Actualización de BC en progreso",
      "9": "Actualización de BMU en progreso",
      "10": "Actualización de PCU en progreso",
      "11": "Modo de hibernación",
      "12": "Cargando",
      "13": "Descargando",
      "14": "La capacidad de la batería es de entre: 75-100 %",
      "15": "La capacidad de la batería es de entre: 50-75 %",
      "16": "La capacidad de la batería es de entre: 25-50 %",
      "17": "La capacidad de la batería es de entre: 0-25 %",
      "18": "Sistema ACTIVO"
    },
    "enpowerRow": {
      "code": {
        "-1": "Desconocido",
        "0": "Error del Controlador del sistema (En red)",
        "1": "Error del Controlador del sistema (Fuera de red)",
        "2": "El Controlador del sistema está en modo de apagado rápido/anulación manual",
        "3": "Controlador del sistema Fuera de red; DERs desconectados",
        "4": "Controlador del sistema operativo, no puede detectar ninguna Batería IQ a través de CAN (En red)",
        "5": "Controlador del sistema operativo, no puede detectar al menos una Batería IQ a través de CAN (En red)",
        "6": "Controlador del sistema operativo, no puede detectar al menos una Batería IQ a través de CAN (Fuera de red)",
        "7": "Controlador del sistema Fuera de red; realizando la recuperación del SoC",
        "8": "El Controlador del sistema se está sincronizándose con la red",
        "9": "Actualización del FW del Controlador del sistema (En red)",
        "10": "Actualización del FW del Controlador del sistema (Fuera de red)",
        "11": "Controlador del sistema ACTIVADO, arrancando",
        "12": "Controlador del sistema ACTIVADO y En red",
        "13": "Controlador del sistema ACTIVADO y Fuera de red",
        "14": "Controlador del sistema APAGADO"
      }
    },
    "info": {
      "safetyIssue": "Ninguno de los estados de LED presenta un problema de seguridad",
      "title": {
        "flashingRed": "Rojo parpadeante",
        "flashingYellow": "Amarillo parpadeante",
        "softPulseYellow": "Pulso débil amarillo",
        "softPulseBlue": "Pulso débil azul",
        "softPulseGreen": "Pulso débil verde",
        "solidRed": "Rojo sólido",
        "solidYellow": "Amarillo sólido",
        "solidBlueOrGreen": "Azul o verde sólido",
        "ledOff": "Apagado"
      },
      "desc": {
        "flashingRed": "La actualización falló o la batería está en estado de error. Póngase contacto con su instalador o con el Servicio de Atención al Cliente de Enphase.",
        "flashingYellow": "Actualización en progreso.",
        "softPulseYellow": "Modo de hibernación activado.",
        "softPulseBlue": "Descargando.",
        "softPulseGreen": "Cargando.",
        "solidRed": "Arrancando.",
        "solidYellow": "No funciona debido a la alta temperatura. Consulte la \"Solución de problemas de la IQ Battery\" A para obtener más detalles.",
        "solidBlueOrGreen": "Inactivo. El color cambia de azul a verde a medida que cambia el estado de carga. El estado de carga se actualiza en la aplicación Enphase. Consulte \"Solución de problemas de IQ Battery\" C para obtener más detalles.",
        "ledOff": "No funciona. Consulte la \"Solución de problemas de la IQ Battery\" B para obtener más detalles."
      }
    }
  },
  "updatePending": {
    "title": "Carga de datos en progreso",
    "content": "Su Puerta de enlace está subiendo los datos de su sistema a la nube de Enphase. Esto ocurre cuando la Puerta de enlace ha estado desconectada durante algún tiempo. Normalmente tarda 1 hora por cada día para que la Puerta de enlace está desconectada. No se preocupe, el mensaje desaparecerá una vez que se hayan cargado todos los datos.",
    "envoyDataTitle": "Carga de datos",
    "envoyDataContent": "Su sistema se conectó recientemente a Internet y está tardando algún tiempo en cargar sus datos. Puede tomar hasta una hora por cada día que estuvo desconectado."
  },
  "bkpConfig": {
    "title": "Configuración de Respaldo",
    "0": "No seleccionado",
    "1": "Copia de seguridad parcial del hogar",
    "2": "Copia de seguridad completa del hogar"
  },
  "set": "Seleccione",
  "change": "Cambio",
  "allTopics": "Todos los Temas",
  "referFriends": {
    "title": "Recomiende amigos",
    "subTitle_1": "para dar ",
    "subTitle_2": " y obtener ",
    "description_1": "Tanto usted como su amigo serán elegibles para recibir una tarjeta de regalo de ",
    "description_2": " cada uno, después de que su amigo compre y active un nuevo sistema solar o de almacenamiento Enphase usando el enlace a continuación. ",
    "description_3": " cada uno, después de que su amigo compre y active un nuevo sistema solar Enphase usando el enlace a continuación. ",
    "urlHeading": "Su URL de referencia",
    "shareButton": "Comparta su enlace de referencia",
    "copyButton": "Copie su enlace de referencia",
    "termsConditions": "Términos y Condiciones",
    "applyTerms": "aplicar.",
    "toastMessage": "Enlace de referencia copiado a su portapapeles",
    "shareMessage_1": "¡Oye! ¿Sabía que mi casa funciona con energía solar? Si estaba pensando en pasarse a la energía solar, este es el momento. Tengo un enlace de referencia exclusivo que puede usar para recibir ",
    "shareMessage_2": " cuando active un nuevo sistema solar Enphase.",
    "shareMessageAU_1": "Hey! Getting Enphase solar for my home is one the best investments I've made so I'm sharing the sunshine. If you’re considering ways to lower your electricity bills and protect your pocket, I have a referral link that you can use to receive ",
    "shareMessageAU_2": " when you go solar with Enphase. Check it out:",
    "tncTitle": "Términos y condiciones del Programa de referidos de Enphase:",
    "important_title": "Importante",
    "important_subtitle": "Usted y su amigo solo serán elegibles para el cupón si:",
    "important_1": "Hay un intervalo de al menos 15 días entre el registro completo y la instalación.",
    "important_2": "La dirección de correo electrónico con la que se recibe o registra la referencia se utiliza para activar el sistema, una vez instalado",
    "tnc": {
      "1": "Límite de 30 referidos por cliente.",
      "2": "Los referidos deben usar el enlace que usted comparte y proporcionar su información de contacto a Enphase a través del sitio web designado de Enphase el 31 de diciembre de 2022 o antes.",
      "3": "Si Enphase o sus instaladores ya tienen el ID de correo electrónico proporcionado por el Referido, su recomendación no será elegible para participar en este Programa de referidos.",
      "4": "Usted y su Referido serán elegibles para recibir las Tarjetas de Regalo solo si su Referido compra, instala y completa la activación de su producto Enphase dentro de los 2 años siguientes a la recepción por parte de Enphase de la información del Referido en el sitio de Enphase.",
      "5": "Una vez recibida la notificación de Enphase de que usted y su Referido son elegibles para recibir la Tarjeta de regalo, debe reclamar la Tarjeta de regalo dentro de los 90 días de haber recibido dicha notificación.",
      "6_One": "Si las Tarjetas de regalo de ",
      "6_Two": " no están disponibles, Enphase puede sustituirlas por otro premio de igual o mayor valor.",
      "7": "El monto de la Tarjeta de regalo seleccionado refleja una estimación del valor de la referencia frente a los gastos de marketing ahorrados en la contratación de nuevos clientes.",
      "8": "Si usted o su Referido desean retirarse del Programa de referidos o recibir la recompensa de la Tarjeta de regalo, comuníquese con el Enphase",
      "9": "Enphase no será responsable de envíos confusos, incorrectos, incompletos o retrasados, ni será responsable de errores tipográficos, problemas al cargar o descargar la información del Referido, ni por cualquier otro mal funcionamiento técnico de las redes, Internet, equipos electrónicos o sitios web.",
      "10": "Enphase se reserva el derecho de modificar, suspender o finalizar este Programa de referidos sin previo aviso.",
      "11": "Este Programa de referidos es nulo donde esté prohibido.",
      "12": "Para que Enphase atribuya una referencia, usted y su referido deben usar el enlace único.",
      "13": "Debe haber un intervalo de al menos 15 días entre el registro completo y la instalación.",
      "14": "La dirección de correo electrónico con la que se recibe o registra la referencia debe utilizarse para activar el sistema, una vez instalado."
    }
  },
  "contactPVMaintainer": "Póngase en contacto con el mantenedor solar",
  "contactStorageMaintainer": "Póngase en contacto con el encargado de almacenamiento",
  "pvInstallerDetails": "Detalles del instalador solar",
  "storageInstallerDetails": "Detalles del instalador de almacenamiento",
  "customerSupport": "Soporte al Cliente",
  "soFarToday": "Hasta el momento actual,",
  "forSelectedPeriod": "Para el período seleccionado,",
  "energyIndependence": {
    "title": "Independencia energética",
    "subTitle": "Mida su independencia de la energía de la red pública",
    "formulaText": "Cómputo de Independencia Enenrgética:",
    "formula": "[1-(Importado/Consumido)] * 100%",
    "formulaForGenerator": "[1 - {(Importada de la red + Importada del generador) / Consumida}] * 100 %",
    "desc1": "La independencia energética es un indicador de la autosuficiencia energética. Esto significa que usted mismo puede cubrir toda su demanda de energía.",
    "unknown": "se desconoce, ya que su sistema no ha reportado ningún dato de consumo.",
    "0": "toda la energía que consume proviene de una fuente externa, tal como la red eléctrica. Esto significa que su puntuación de independencia energética para %{periodValue} %{eiValue}%.",
    "100": "nada de la energía que consume proviene de una fuente externa, tal como la red eléctrica. Esto significa que su puntuación de independencia energética para %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% de la energía que consume proviene de una fuente externa, tal como la red eléctrica. Esto significa que su puntuación de independencia energética para %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "hoy es",
    "forSelectedPeriod": "el período seleccionado es",
    "addStorageTitle": "Añade baterías",
    "addStorage": "para incrementar su Independencia Energética.",
    "addStorageTitleWB": "Agregar energía solar o de almacenamiento",
    "addStorageWB": "aumenta su Independencia Energética.",
    "clarify": "La Independencia Energética no incluye la energía exportada y no debe confundirse con la Medición Neta (o Energía Neta), que es la diferencia entre la energía importada y la exportada"
  },
  "backupHistory": {
    "backupEvents": "Total de eventos de respaldo"
  },
  "eventHistory": {
    "totalEvents": "Total de Enventos",
    "events": "Evento",
    "deviceImpacted": "Dispositivo impactado",
    "recommendedAction": "Acción recomendada",
    "noBackupHistoryFound": "Historial de acumulación no encontrado",
    "eventStatus": "Estado del evento"
  },
  "siteActivationStage": {
    "title": " ha iniciado la activación de su sistema Enphase, ",
    "learnToUse": "Aprenda a utilizar la aplicación de Enphase para supervisar su nuevo sistema Enphase."
  },
  "sfdcChatBot": {
    "exitConfirmation": "¿Está seguro de que desea cerrar el habla con nosotros",
    "sfdcChatSubject": "Chat desde la aplicación de Enphase",
    "offlineSupport": "Lamentablemente, nuestros agentes están fuera de línea. Por favor, déjenos un mensaje."
  },
  "pushN": {
    "ok": "Ok, ve allí",
    "stay": "Quédate aquí",
    "permMsg": "Ha recibido una notificación para el sitio %{siteName}. Cambie a este sitio para ver la notificación."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "¿Qué modo debería elegir?",
    "autofillRatePlanExistFAQ": "¿Por qué no aparece mi plan de tarifas?",
    "autofillRatePlanMatchFAQ": "¿Por qué mis datos no coinciden con mi factura?",
    "autofillTariffNote": "Si tienes dificultades para encontrar el nombre o el código de la tarifa, ponte en contacto con tu proveedor eléctrico para obtener más información.",
    "whtBaslineElecRate": "¿Cuál es su tarifa básica de pago de electricidad? ",
    "doElecPayRateVaryWeekends": "¿Varía su tarifa de pago de electricidad los fines de semana? ",
    "doElecPayRateVarySeasonaly": "¿Varía su tarifa de pago de electricidad según la temporada? ",
    "elecPayGoesUpWithUsage": "¿Aumenta su tarifa de pago de electricidad a medida que aumenta su uso? ",
    "pRatePeakOffPecakChanges": "¿Tiene su tarifa de pago de electricidad cambios durante y fuera de las horas punta? ",
    "ratePerUnitOfSolar": "¿Cuál es su tarifa de pago por unidad de energía solar generada? ",
    "payOutRate": "Tarifa de pago ",
    "tarifeditorConstants1": "Estructura de las tarifas de electricidad ",
    "tarifeditorConstants2": "Convierte datos de energía en tasas de cambio equivalentes ",
    "tarifeditorConstants3": "Ver/editar la estructura de la tarifas de electricidad de su empresa de servicios públicos ",
    "tarifeditorConstants4": "Puede verificar la información de la tarifa de importación de electricidad en su factura de servicios públicos en la sección que indica los detalles de sus cargos eléctricos. ",
    "tarifeditorConstants5": "Agregar tarifa de importación de electricidad ",
    "tarifeditorConstants6": "Establezca la estructura de tarifas a la que su empresa de servicios públicos le cobrará por importar electricidad de la red. ",
    "tarifeditorConstants7": "Nota ",
    "tarifeditorConstants8": "La información sobre tarifas de electricidad es utilizada por la Gateway para determinar cuáles son los mejores horarios para la carga y la descarga de las baterías cuando el perfil de su batería esté configurado en \"Modo de ahorro\". Si modifica esta información, el comportamiento del sistema cambiará.",
    "tarifeditorConstants9": "No se agrega la estructura de la tarifa de electricidad ",
    "tarifeditorConstants10": "Agregar tarifa de importación de electricidad ",
    "tarifeditorConstants11": "Seleccionar un modo para agregar sus detalles ",
    "tarifeditorConstants12": "Autocompletar ",
    "tarifeditorConstants13": "Importar su estructura de las tarifas de electricidad utilizando la información de su empresa de servicios públicos ",
    "tarifeditorConstants14": "Manual ",
    "tarifeditorConstants15": "Rellenar manualmente los detalles de la estructura de las tarifas de electricidad de su empresa de servicios públicos ",
    "tarifeditorConstants16": "Código postal ",
    "tarifeditorConstants17": "Nombre de la empresa de servicio público ",
    "tarifeditorConstants18": "Nombre/Código de tarifa ",
    "tarifeditorConstants19": "Detalles de la tarifa de importación de electricidad ",
    "tarifeditorConstants20": "Tarifa plana ",
    "tarifeditorConstants21": "Escalonada ",
    "tarifeditorConstants22": "Tiempo de uso ",
    "tarifeditorConstants23": "Tarifa fija ",
    "tarifeditorConstants24": "Descargo de responsabilidad ",
    "tarifeditorConstants25": "Las tarifas eléctricas informadas son cambios agrupados que incluyen solo componentes de tarifas basados ",
    "tarifeditorConstants26": "Confirmar y guardar ",
    "tarifeditorConstants27": "Nombre de la tarifa de electricidad ",
    "tarifeditorConstants28": "Tarifa básica de electricidad ",
    "tarifeditorConstants29": "¿Está seguro de que quiere restablecer los detalles? ",
    "tarifeditorConstants30": "¿Tiene su tarifa de electricidad cargos durante y fuera de las horas punta? ",
    "tarifeditorConstants31": "¿Aumenta su tarifa de electricidad a medida que aumenta su uso? ",
    "tarifeditorConstants32": "Tarifa de Electricidad fija que no varía. ",
    "tarifeditorConstants33": "La tarifa de la electricidad aumenta a medida que aumenta el uso. ",
    "tarifeditorConstants34": "¿Varía su tarifa de electricidad según la temporada? ",
    "tarifeditorConstants35": "¿Varía su tarifa de electricidad los fines de semana? ",
    "tarifeditorConstants36": "¿Cuál es su tarifa básica de electricidad? ",
    "tarifeditorConstants37": "Tarifa de Electricidad fija que no varía. ",
    "tarifeditorConstants38": "La estructura de la tarifa de electricidad varía solo según la temporada. ",
    "tarifeditorConstants39": "La estructura de la tarifa de electricidad varía los fines de semana. ",
    "tarifeditorConstants40": "La estructura de la tarifa de electricidad varía según la temporada y los fines de semana. ",
    "tarifeditorConstants41": "La tarifa de electricidad aumenta a medida que aumenta el uso. ",
    "tarifeditorConstants42": "Tarifa de electricidad básica: ",
    "tarifeditorConstants43": "La estructura de la tarifa de electricidad varía solo según la temporada. ",
    "tarifeditorConstants44": "La tarifa de electricidad tiene cargos durante y fuera de las horas punta. ",
    "tarifeditorConstants45": "La estructura de la tarifa de electricidad varía solo los fines de semana. ",
    "tarifeditorConstants46": "Agregar tarifa de exportación de electricidad ",
    "tarifeditorConstants47": "Agregar la estructura de tarifas a las que se le paga por exportar su electricidad generada por energía solar a la red. ",
    "tarifeditorConstants48": "Seleccionar su plan de exportación de electricidad ",
    "tarifeditorConstants49": "Cómo seleccionar su plan de exportación de electricidad ",
    "tarifeditorConstants50": "Puede verificar esta información en su factura de servicios públicos en la sección que indica sus créditos y ajustes. ",
    "tarifeditorConstants51": "MEN (Medición de energía neta) ",
    "tarifeditorConstants52": "Compruebe si tiene una configuración de medidor de red en su vivienda. <b style='font-weight: bold;'>Su tarifa de importación de electricidad se copiará como su tarifa de exportación de electricidad.</b> ",
    "tarifeditorConstants53": "FIT neta (Tarifa de alimentación neta) ",
    "tarifeditorConstants54": "Marcar esto si solo le pagan por la energía solar que vuelve a la red desde su vivienda. ",
    "tarifeditorConstants55": "FIT bruto (Tarifa de alimentación bruta) ",
    "tarifeditorConstants56": "Marcar esto si le pagan por cada unidad de electricidad generada por sus paneles solares. ",
    "tarifeditorConstants57": "Otro ",
    "tarifeditorConstants58": "Marcar esto si tiene algún otro plan. ",
    "tarifeditorConstants59": "Detalles de la tarifa de exportación de electricidad ",
    "tarifeditorConstants60": "Estructura de las tarifas de pago de electricidad ",
    "tarifeditorConstants61": "Plan de exportación ",
    "tarifeditorConstants62": "Editar la tarifa de exportación de electricidad ",
    "tarifeditorConstants63": "¿Le paga su plan FIT a un precio fijo por unidad de energía solar exportada? ",
    "tarifeditorConstants64": "Tarifa variable en el tiempo ",
    "tarifeditorConstants65": "La tarifa de pago de electricidad tiene cargos durante y fuera de las horas punta ",
    "tarifeditorConstants66": "Tarifa de pago de electricidad fija que no varía ",
    "tec67": "Tarifa de pago de electricidad de referencia",
    "tec68": "Nombre de la tarifa",
    "tec69": "Lamentamos informarle que su plan tarifario no es compatible con la opción de autollenado. Estamos trabajando para solucionar esto. Mientras tanto, puede establecer su plan tarifario utilizando el flujo manual.",
    "tec70": "No se pudo conseguir el nombre del servicio público para su código postal. Establezca el plan tarifario manualmente.",
    "tec71": "Lo sentimos, no pudimos conseguir la información del plan tarifario.",
    "tec72": "Seleccionar el nombre del servicio público",
    "tec73": "Buscar",
    "tec74": "Nombre del plan tarifario/Código",
    "tec75": "Seleccionar el nombre del plan tarifario/código",
    "tec76": "Establecer plan tarifario manualmente",
    "tec77": "Inténtelo de nuevo",
    "tec78": "Seleccionar el horario de carga",
    "tec79": "Cargar baterías desde la red eléctrica",
    "from": "Desde",
    "to": "Hasta",
    "tec80": "La carga de las baterías desde la red se actualizó con éxito",
    "try_again": "Vuelva a intentarlo.",
    "tec81": "Calificar su experiencia",
    "tec82": "¿Fue esta información útil y precisa?",
    "tec83": "No es probable",
    "tec84": "Es muy probable",
    "tec85": "Por preguntas o aclaraciones, escríbanos.",
    "tec86": "¿No quiere que sus baterías se carguen desde la red?",
    "tec87": "Thank you for your valuable feedback",
    "talc": "Vuelva a intentarlo más tarde",
    "tec88": "¿Cómo es su experiencia con el editor de planes tarifarios?",
    "tec89": "Nota",
    "tec90": "Copiar desde plan tarifario de compra",
    "tec91": "Copiar su configuración de planes tarifarios desde el plan tarifario de compra establecido",
    "tec92": "Tarifa de exportación de electricidad",
    "tec93": "Tarifa de importación de electricidad",
    "tec94": "La tarifa de electricidad mostrada aquí se conforma según los componentes que se muestran a continuación.",
    "tec95": "Responda las preguntas a continuación para configurar su tipo de plan tarifario.",
    "tec96": "Intervalo de tiempo no válido",
    "tec97": "%{time1} - %{time2} ya se ha seleccionado",
    "peak": "Pico",
    "aPeak": "Añadir Pico",
    "aSeason": "Añadir Temporada",
    "season": "Temporada",
    "eSeason": "Editar Temporada",
    "tec98": "Entrada no válida. El valor debería ser mayor que el Nivel %{index}",
    "tec99": "Se produjo un error. Vuelva a intentarlo más tarde.",
    "tec100": "La tarifa de pago de la electricidad aumenta conforme al uso.",
    "tec101": "Tarifa que varía según el horario",
    "tier": "Nivel",
    "offPeak": "Fuera de pico",
    "tec102": "Editar tarifa de importación de electricidad",
    "tec103": "configuración manual",
    "tec104": "tarifa de autocompletar",
    "tec105": "Seleccionar un modo",
    "tec106": "Seleccionar un modo para editar sus detalles ",
    "tec107": "Seleccionar nombre de plan tarifario",
    "tec108": "La información sobre tarifas de electricidad es utilizada por la Gateway para determinar cuáles son los mejores horarios para la carga y la descarga de las baterías. Si modifica esta información, el comportamiento del sistema cambiará.",
    "tec109": "La información sobre tarifas de electricidad se utiliza para calcular sus ahorros de energía en el tiempo, y para brindarle recomendaciones personalizadas que le ayuden a ahorrar en la factura de energía.",
    "tec110": "¿Cuál es su tarifa de pago por unidad de energía solar exportada?",
    "tec111": "La tarifa de importación de electricidad se añadió con éxito",
    "tec112": "La tarifa de importación de electricidad se actualizó con éxito",
    "tec113": "La tarifa de importación de electricidad se restableció con éxito",
    "tec114": "La tarifa de exportación de electricidad se añadió con éxito",
    "tec115": "La tarifa de exportación de electricidad se actualizó con éxito",
    "tec116": "La tarifa de exportación de electricidad se restableció con éxito",
    "rate": "Precio",
    "tec117": "Tasa de pago fija",
    "tec118": "Otro (Escalonada )",
    "tec119": "Otro (Tiempo de uso )",
    "tec120": "Otro (Tarifa plana )",
    "tec121": "Otro FIT",
    "tec122": "Net FIT (Tarifa que varía según el horario)",
    "tec123": "Net FIT (Tarifa plana )",
    "tec124": "NEM",
    "tec125": "Tarifa de Electricidad fija que no varía. La estructura de la tarifa de electricidad varía solo según la temporada.",
    "tec126": "Tarifa de Electricidad fija que no varía. La estructura de la tarifa de electricidad varía solo los fines de semana.",
    "tec127": "Tarifa de Electricidad fija que no varía. La estructura de la tarifa de electricidad varía según la temporada y los fines de semana.",
    "tec128": "Tarifa de pago de electricidad fija que no varía. La estructura de la tarifa de electricidad varía solo según la temporada.",
    "tec129": "Tarifa de pago de electricidad fija que no varía. La estructura de la tarifa de electricidad varía solo los fines de semana.",
    "tec130": "Tarifa de pago de electricidad fija que no varía. La estructura de la tarifa de electricidad varía según la temporada y los fines de semana.",
    "tec131": "La tarifa de electricidad tiene cargos durante y fuera de las horas punta. La estructura de la tarifa de electricidad varía solo según la temporada.",
    "tec132": "La tarifa de electricidad tiene cargos durante y fuera de las horas punta. La estructura de la tarifa de electricidad varía solo los fines de semana.",
    "tec133": "La tarifa de electricidad tiene cargos durante y fuera de las horas punta. La estructura de la tarifa de electricidad varía según la temporada y los fines de semana.",
    "tec134": "La tarifa de pago de electricidad tiene cargos durante y fuera de las horas punta. La estructura de la tarifa de electricidad varía solo según la temporada.",
    "tec135": "La tarifa de pago de electricidad tiene cargos durante y fuera de las horas punta. La estructura de la tarifa de electricidad varía solo los fines de semana.",
    "tec136": "La tarifa de pago de electricidad tiene cargos durante y fuera de las horas punta. La estructura de la tarifa de electricidad varía según la temporada y los fines de semana.",
    "tec137": "La tarifa de electricidad aumenta a medida que aumenta el uso. La estructura de la tarifa de electricidad varía solo según la temporada.",
    "tec138": "La tarifa de pago de la electricidad aumenta conforme al uso. La estructura de la tarifa de electricidad varía solo según la temporada.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Mostrar tarifas históricas",
    "tec141": "Tarifa de importación de electricidad añadida con éxito",
    "tec142": "Valore su experiencia al añadir la tarifa de electricidad",
    "tec143": "Insatisfecho",
    "tec144": "Satisfecho",
    "tec145": "Omitir",
    "tedc0": "Cargo por demanda",
    "tedc1": "Cargo por demanda durante todo el día (24 horas)",
    "tedc2": "Su tarifa de electricidad incluye el componente de cargo por demanda agregado mensualmente a su factura de electricidad.",
    "tedc3": "Su tarifa eléctrica incluye el componente de carga de la demanda. Durante las horas punta, el consumo máximo para cualquier intervalo de %{time}-minuto durante el mes se cobrará de acuerdo con los siguientes detalles",
    "tedc4": "Consumo máx. de %{time} min",
    "tedc5": "Seleccione una estructura de tarifa eléctrica",
    "tet1": "Quiero saber más sobre añadir la tarifa de electricidad",
    "tet2": "En algunas zonas, el costo de la electricidad varía durante el día según el consumo. Usamos su tarifa de electricidad para planificar el mejor momento para cargar y descargar sus baterías cuando su perfil está configurado en Modo de ahorro.",
    "tet3": "Introducción",
    "tet4": "Toque 'Añadir tarifa de importación de electricidad'.",
    "tet5": "Introduzca su información",
    "tet6": "Utilice autorrellenar o introduzca manualmente la información sobre su tarifa. Es posible que necesite una factura de luz actual si introduce la tarifa manualmente.",
    "tet7": "Autorrellenar",
    "tet8": "Seleccione su servicio público de electricidad y el nombre o código de su plan en los menús desplegables. La aplicación buscará automáticamente tu tarifa de importación de electricidad.",
    "tet9": "Manual",
    "tet10": "Introduzca la información en cada campo. Es posible que deba consultar una factura de luz actual para reunir toda la información necesaria.",
    "tet11": "Añadir tarifa de exportación de electricidad",
    "tet12": "Si obtiene crédito por devolver electricidad a la red, añada la tarifa de exportación de electricidad. Toque 'Añadir tarifa de exportación de electricidad' para comenzar. Tendrá las mismas opciones para introducir la información manualmente o con autorrellenar.",
    "tet13": "Cómo determinamos y usamos su tarifa de electricidad",
    "undefined": "Otro (con niveles)",
    "timeDiffError": "La hora de inicio y de finalización debe tener una diferencia mínima de 15 minutos",
    "periodOverlapError": "Este periodo se superpone con uno de los otros periodos",
    "peakConflictError": "La tasa pico debe ser mayor que la tasa de fuera de pico",
    "isTimeValid": 'La hora de inicio debe ser anterior a la hora de finalización'
  },
  "appliance": {
    "info": "Para mantener su casa con energía durante periodos prolongados de tiempo y durante un corte de la red, le recomendamos que minimice y gestione su consumo de energía",
    "desc": "Apague las cargas domésticas no críticas para aumentar la duración de la batería.",
    "descSystem2_0AndEncharge": "Prácticas recomendadas durante un apagón.",
    "largeAppliances": "Grandes electrodomésticos",
    "useSparingly": "Utilizar con moderación",
    "essentialAppliances": "Electrodomésticos esenciales",
    "useNormally": "Usar normalmente",
    "airConditioner": "Aire acondicionado",
    "dishwasher": "Lavavajillas",
    "poolPump": "Bomba de piscina",
    "washingMachine": "Lavadora",
    "electricVehicle": "Vehículo eléctrico",
    "electricDryer": "Secadora eléctrica",
    "lights": "Luces",
    "laptop": "Ordenador portátil",
    "television": "Televisión",
    "refrigerator": "Refrigerador",
    "wifiRouter": "Router de wifi",
    "microwave": "Microondas"
  },
  "rootedAlert": {
    "exitBtn": "Salir",
    "proceedBtn": "Proceder",
    "agreeBtn": "Estoy de acuerdo",
    "warningLabel": "¡ADVERTENCIA!",
    "warningTextInitial": "Su dispositivo parece estar enraizado. El enraizamiento compromete la protección de seguridad por defecto y hace los datos almacenados en su dispositivo vulnerables. No se recomienda ejecutar la aplicación de Enphase en un dispositivo enraizado.",
    "warningTextFinal": "Al continuar, comprendo y acepto que Enphase no será responsable de ningún funcionamiento incorrecto o consecuencia de ejecutar la aplicación de Enphase en este dispositivo enraizado."
  },
  "generator": {
    "exerciseModeOverlap1": "El tiempo de ejercicio se solapa con su tiempo de reposo",
    "exerciseModeOverlap2": "a",
    "exerciseModeOverlap3": "Quiere usted continuar?",
    "dayInWeek": "Día en semana",
    "time": "Hora",
    "duration": "Duración",
    "frequency": "Frecuencia",
    "save": "Enregistrer",
    "edit": "MODIFIER",
    "cancelRequest": "Annuler la demande",
    "activate": "Activer",
    "okayText": "OK, j’ai compris !",
    "batteryUnavailable": "<span>Votre système n//’a pas de batterie. Vous voulez contrôler votre générateur selon la charge de la batterie ? <a href='https://estimator.enphaseenergy.com/login' target='_blank'>Ajouter du stockage</a></span>",
    "suspendedStateText": "Actualmente su generador está desactivado. Active su generador con el botón de la parte superior de la pantalla para activar el perfil del generador.",
    "suspendedModalHeading": "Su generador se desactivará.",
    "suspendedModalHeading_1": "Su generador se encenderá en función del perfil seleccionado.",
    "suspendedModalSubheading": "Para activar el generador, utilice el botón de alternancia en la parte superior de la pantalla.",
    "infoHeadng": "Générateur",
    "infoSubheading": "<div><div>Cuando está <span style='color: #F37320'>Activado</span>, su generador se encenderá y apagará en función del perfil seleccionado y la disponibilidad de la red. Si su sistema está Conectado a la red, su generador se apagará independientemente de los perfiles seleccionados.</div><div style='margin-top: 10px;'> Puede desactivar su generador cuando no esté en uso, por ejemplo, cuando se va de vacaciones.<div></div>",
    "advancedSettings": "Ajustes avanzados",
    "pendingRequest": "Solicitud pendiente",
    "disabled": "Désactivé",
    "disable": "Desactivar",
    "enabled": "Activé",
    "waiting": "En attente d’informations",
    "active": "Actif",
    "deviceDetails": "Seleccionar un perfil inteligente para controlar su %{manufacturer} %{modelNumber}.",
    "autoStart": "Autoencendido",
    "autoStartSubheading": "Úselo si desea encender su generador tan pronto como su sistema cambie al modo Fuera de red",
    "batteryOptimizationSubheading": "Úselo si desea encender su generador solo cuando la carga de la batería esté por debajo de cierto nivel y su sistema está Fuera de red.",
    "batteryChargeThreshold": "Límite de carga de batería",
    "lowerLimit": "Límite reducido: ",
    "upperLimit": "Límite superior: ",
    "start": "Inicio: ",
    "stop": "Detener: ",
    "addQuietTime": "Ajouter un temps calme",
    "quietTime": "Temps calme",
    "quietTimeToggle": "Úselo si no desea encender su generador durante este tiempo. Cuando la batería alcanza el límite crítico, el generador se encenderá independientemente del tiempo de reposo.",
    "startTime": "Hora de inicio: ",
    "endTime": "Hora de fin: ",
    "criticalChargeSettings": "Configuración de carga crítica:",
    "generatorLoadingToast": "La confirmación del estado del generador está tardando más de lo esperado. Vuelve a comprobarlo más tarde.",
    "exerciseMode": "Paramètres d’exercice",
    "exerciseModeSubheading": "Se utiliza para hacer funcionar el generador automáticamente a intervalos regulares para mantenerlo en buenas condiciones de funcionamiento.",
    "batteryOptimization": "Inicio en función del nivel de la batería",
    "activateBatteryProfile": "Ha seleccionado el perfil de Inicio automático. Active el perfil \"Inicio basado en el nivel de batería\" para agregar Tiempo de reposo",
    "manualMode": "Modo manual",
    "manualModeDescription": "Su generador está funcionando actualmente en modo manual. Cambie el modo de su generador a automático o comuníquese con su instalador.",
    "generatorStartLimit": "El Límite de arranque no puede ser menor que 10 %",
    "generatorStartStopLimit": "El límite de arranque y el límite de parada deben tener una diferencia mínima de 5 %",
    "generatorLimitDescription": "Use esta función para evitar el encendido del generador en períodos de tiempo específicos. El generador se enciende cuando la carga de la batería cae por debajo del límite de carga crítico.",
    "generatorQuietTime": "Tiempo en modo silencioso",
    "generatorNormalTime": "Tiempo en modo normal",
    "generatorEnableGenerator": "Activar generador",
    "generatorDisableGenerator": "Desactivar generador",
    "automatic": "Automático",
    "ecoFriendly": "Ecológico"
  },
  "sgipStatic": {
    "applyForIncentive": "Solicitar incentivo Sgip",
    "subheadingSgip": "Los propietarios de sistemas en California, que están planeando comprar o han comprado una batería de Enphase para sus hogares, pueden solicitar el SGIP",
    "applyNow": "Solicitar ahora",
    "learnMore": "Más información",
    "serviceFee": "* Puede aplicarse una tasa de servicio",
    "enphaseRepresentative": "* Usted puede ser contactado por un representante de Enphase a través de llamada / correo electrónico",
    "documentsRequired": "Los siguientes documentos son necesarios para solicitar el incentivo SGIP:",
    "documentHeading1": "1. Últimas facturas de servicios públicos (Al menos una factura de los últimos 3 meses)",
    "documentHeading2": "2. Documento del contrato",
    "additionalInfo": "* Pueden requerirse documentos adicionales antes del pago final del incentivo"
  },
  "activationProgress": {
    "systemActivationInProgress": "La activación de su sistema está en curso",
    "completed": "Completado",
    "viewDetails": "Ver detalles",
    "activationCompleted": "La activación se ha completado al 100 %",
    "activationInProgress": "Activación en curso",
    "devices": "Dispositivos",
    "status": "Status",
    "envoy": "Gateway",
    "encharge": "Batería",
    "enpower": "Controlador del sistema",
    "pvProduction": "Producción PV",
    "cosumptionCT": "Consumo de CT",
    "systemOperational": "Sistema operativo",
    "reporting": "Reportando",
    "notReporting": "No informan",
    "enabled": "Habilitado",
    "notEnabled": "No habilitado",
    "producing": "Produciendo",
    "verified": "Verificado",
    "notVerified": "No verificado",
    "featuresNowEnable": "Las siguientes funciones están ahora habilitadas.",
    "featuresWillBeEnabled": "Las siguientes funciones se habilitarán una vez que se haya completado la activación del sistema:",
    "consumptionMonitoring": "Monitorización del consumo",
    "liveStatus": "Estado en vivo",
    "stormGuard": "Protección de Tormenta",
    "batteryProfileSetting": "Ajustes del Perfil de la Batería",
    "gridControl": "Control de red"
  },
  "prodIssue_faq_1": "Por qué uno de mis paneles produce menos que los demás?",
  "prodIssue_faq_2": "Es común que los paneles en el mismo techo varíen en la generación de energía. Muchos factores pueden causar estas variaciones, como la dirección del panel, la sombra de chimeneas o árboles y otras obstrucciones.",
  "accountNew": {
    "account": {
      "title": "Su información",
      "title_alternate": "Informacion personal",
      "save_changes": "Guardar cambios",
      "name_label": "Nombre:",
      "phone_label": "Móvil:",
      "phone_placeholder": "Número de teléfono",
      "first_name_placeholder": "Nombre",
      "last_name_placeholder": "Apellido",
      "email_placeholder": "Dirección de email",
      "email_label": "Email:",
      "change_password": "Cambiar contraseña",
      "current_password": "Contraseña actual:",
      "password_label": "Contraseña nueva:",
      "password2_label": "Vuelva a escribir la contraseña nueva:",
      "password_footnote": "Las contraseñas deben tener al menos 6 caracteres y contener 1 número o un carácter especial como mínimo.",
      "cancel_change_password": "No cambie la contraseña.",
      "units_label": "Unidades:",
      "units_metric": "Métrico (°C, km)",
      "units_us": "Imperial (°F, millas)",
      "locale_label": "Idioma",
      "equivalent_label": "Equivalente energético:",
      "equivalent_display": "Comenzar con",
      "notification_label": "Emails:",
      "preference_monthly_email": "Enviarme resúmenes mensuales del rendimiento del sistema",
      "preference_enphase_email": "Enviarme boletines, promociones y encuestas relacionadas con los productos o servicios de Enphase",
      "production_issues_email": "Notificarme sobre la producción del sistema o problemas relacionados con el servicio",
      "save_successful": "Se ha guardado su información.",
      "save_successful_email": "Se ha guardado su información. Consulte el siguiente aviso con respecto al cambio de dirección de email.",
      "save_failed": "Error al guardar su información.",
      "system_info": "Información del sistema para %{site_name}",
      "system_weather": "Tiempo del sistema",
      "show_system_weather": "Mostrar funciones del tiempo para este sitio",
      "save": "Guardar"
    },
    "system_preferences": {
      "title": "Preferencias del sistema",
      "name_label": "Nombre:",
      "public_label": "Página pública del sistema:",
      "public_text_html": "Crear una página pública para mi sistema",
      "public_preview_link": "Obtener vista previa de página pública",
      "public_help_link": "Obtener más información",
      "public_footnote": "Esto habilitará funciones de uso compartido en redes sociales y permitirá a distintos usuarios visitar su sistema.",
      "display_label": "Mostrar el nombre del sistema como:",
      "save_changes": "Guardar preferencias del sistema",
      "save_location_changes": "Guardar configuración de privacidad",
      "save_successful": "Se han guardado sus preferencias del sistema.",
      "save_failed": "Error al guardar las preferencias del sistema."
    },
    "validations": {
      "required": "Este campo es obligatorio.",
      "password_too_short": "Su contraseña debe tener al menos seis caracteres y contener número o un carácter especial como mínimo.",
      "password_too_long": "Introduzca menos de 50 caracteres.",
      "password_similar_to_username": "Su contraseña no puede ser la misma que su dirección de email.",
      "password_too_weak": "Su contraseña debe tener al menos seis caracteres y contener número o un carácter especial como mínimo.",
      "password_weak": "Su contraseña debe tener al menos seis caracteres y contener número o un carácter especial como mínimo.",
      "password_good": "Seguridad de la contraseña: buena",
      "password_strong": "Seguridad de la contraseña: segura",
      "password_policy": "La contraseña debe contener entre %{pwd_min_length} y %{pwd_max_length} caracteres e incluir %{digit_in_pwd} dígitos, %{uppercase_in_pwd} letras mayúsculas, %{lowercase_in_pwd} letras minúsculas y %{special_character_in_pwd} caracteres especiales (solo se admiten ~!@#$%^&*)",
      "equalTo": "Por favor, escribe el mismo valor de nuevo.",
      "invalid_phone_number": "Introduzca un número de celular válido.",
      "empty_phone_number": "Introduzca su número de celular.",
      "email_used": "El ID de correo electrónico ya está registrado. Vuelva a intentarlo con otro ID de correo electrónico o $cHere para restablecer su contraseña.",
      "emailInvalid": "Introduce una dirección de correo electrónico válida"
    }
  },
  "accountDelete": {
    "deleteAccount": "Borrar cuenta",
    "deletePopUpText": "Su cuenta y la información personal asociada se eliminarían. Se cerrará la sesión después de eliminar la cuenta. Quieres proceder?",
    "deleteCnfText": "Su cuenta y la información personal asociada se eliminarían, excepto la información que debemos mantener en relación con su Sistema de energía. Se cerrará la sesión después de eliminar la cuenta. Quieres proceder?",
    "yes": "Sí",
    "no": "No",
    "verificationCode": "Código de verificación",
    "enterCodeText": "Ingrese el código de 4 dígitos que se envió a su dirección de correo electrónico registrada y el número de teléfono móvil.",
    "didntReceive": "¿No recibiste el código?",
    "resend": "reenviar",
    "deleteCnfTextEnlm": "Su cuenta y la información personal asociada se eliminarían, excepto la información que debemos mantener en relación con su Sistema de energía. También perderá el acceso a Enlighten Manager. Se cerrará la sesión después de eliminar la cuenta. Quieres proceder?",
    "deleteAdmin": "Su cuenta no se puede eliminar porque es un usuario administrador de Enphase",
    "verifyCode": "Código de verificación",
    "logOutText": "Se cerrará la sesión después de verificar el código.",
    "confirmText": "Su cuenta está desactivada. Conservaremos la información personal relacionada con su sistema de energía para cumplir con su garantía y respaldar su sistema.",
    "ok": "Ok lo tengo",
    "activateCnfText": "Su cuenta de Enphase no está activa porque la ha eliminado. ¿Te gustaría activarlo de nuevo?",
    "activateText": "El ID de correo electrónico está registrado en Enphase. Sin embargo, no está activo ya que fue eliminado.",
    "click": "Hacer clic ",
    "activateAgain": "aquí para activarlo de nuevo",
    "activateAccount": "Activar la cuenta",
    "emailIDRegistered": "El ID de correo electrónico está registrado en Enphase. Sin embargo, no está activo ya que fue eliminado. $cHere para activarlo de nuevo.",
    "deleteAccountPopupText": "Eliminar su cuenta desactivará su cuenta y eliminará toda la información personal asociada con su cuenta. Como está asociado con un sistema de energía de Enphase, estamos obligados a conservar su información personal para respaldar la garantía del producto, las actualizaciones del sistema y el soporte.",
    "learnMore": "Aprende más",
    "accountdeletion": "Su cuenta está en proceso de eliminación. Este proceso puede demorar hasta 30 días y puede crear una nueva cuenta después de que se elimine su cuenta anterior.",
    "incorrectEmailandPass": "El correo electrónico y la contraseña que ingresó no coinciden con nuestros registros. Inténtalo de nuevo.",
    "accountdeletioninfo": "Su cuenta está en proceso de eliminación. Puede tardar hasta 30 días.",
    "WOAccntdeletePopup": "Eliminar su cuenta desactivará su cuenta y eliminará toda la información personal asociada con su cuenta.",
    "accountdelReq": "Solicitud de eliminación de cuenta",
    "verfcodedel": "Su código de verificación para eliminar la cuenta de Enphase",
    "accountActvReq": "Solicitud de activación de cuenta",
    "codedelAccount": "Código de verificación para eliminar la cuenta de Enphase",
    "codeDuration": "Este código solo será válido durante 15 minutos.",
    "userDelReq": "El usuario ha solicitado la opción de eliminación de cuenta en la aplicación Enphase. Encuentre los detalles del usuario a continuación",
    "requestReceived": "Recibimos su solicitud para activar su cuenta de Enphase. Para hacerlo, haga clic en el enlace a continuación dentro de los 7 días posteriores a la recepción de este correo electrónico.",
    "activate": "Activar",
    "accActivate": "activa tu cuenta",
    "optdelaccount": "Su código de verificación para eliminar la cuenta de Enphase es %{otp}. Este código es válido durante 15 minutos.",
    "emailCheckInstruction": "Por favor revise su correo electrónico para obtener instrucciones para activar la cuenta."
  },
  "phase": {
    "all": "Vista trifásica",
    "phaseL": "Fase L",
    "msgOffGrid": "Los datos de consumo de energía por fases no están disponibles cuando su sistema está fuera de la red."
  },
  "vls": {
    "vlsHeading": "Nivel de apagado de la batería",
    "shutdownLevelLine1": "En un corte de energía, su batería se apagará a",
    "shutdownLevelLine1-2": "carga para conservar la energía. Se reinicia utilizando la energía conservada cuando la red pública restablece el suministro o los paneles solares comienzan a producir energía.",
    "shutdownLevelLine2": "Elija un valor alto si está experimentando mal tiempo que afecta a la producción solar.",
    "vlsWarning": "El nivel de apagado de la batería no puede ser superior a la reserva de la batería (%{soc}%)",
    "stormVlsWarning": "La alerta de tormenta está activada para su sistema. Una vez que la alerta de tormenta finalice, la reserva de la batería se actualizará al %{soc}%, ya que la reserva no puede ser inferior al nivel de apagado",
    "batteryReserveWarning": "La reserva de la batería no puede ser inferior al nivel de apagado de la batería (%{horizontal}%). Reduzca el nivel de apagado de la batería desde los #Ajustes Avanzados# para disminuir la reserva de la batería.",
    "editRequest": "Tiene una solicitud activa. Espere la confirmación o cancele esa solicitud para proceder a la selección."
  },
  "defaultLocale": {
    "popContent1": "Elija el idioma de la aplicación",
    "popContentBody1": "¿Le gustaría continuar con ",
    "popContentBody2": " como idioma de su aplicación?",
    "button1": "Bien, continuar",
    "button2": "Elige otro idioma",
    "button3": "No, cambiar a ",
    "en": "inglés",
    "de": "Alemán",
    "es": "español",
    "fr": "Francés",
    "it": "italiano",
    "nl": "Holandés",
    "pl": "Polaco",
    "pt": "portugués",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "¡No hay paneles solares!",
    "noArraysDesc": "Usted no tiene ningún panel solar instalado",
    "noAccessConsumptionData": "Usted no tiene acceso a los datos de consumo para este sitio."
  },
  "drEventsActive": "Evento de RD: Activo",
  "pleaseGoTo": "Ingrese en ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " para actualizar sus preferencias de notificaciones.",
  "loadControl": {
    "enabled": "Habilitado",
    "disabled": "Desactivado",
    "smartEnabled": "Control inteligente habilitado",
    "smartDisabled": "Control inteligente desactivado",
    "offGridBehaviour": "Comportamiento fuera de la red",
    "modeDetails": "Detalles del modo de control inteligente",
    "newModeDetails": "Detalles del Modo de control de cargas",
    "basicMode": "Modo básico",
    "cannotUse": "No se puede utilizar %{loadName}",
    "genOnUSe": "%{loadName} se puede usar cuando el generador está encendido",
    "genMode": "Modo generador",
    "batteryMode": "Modo batería",
    "batteryModePercent": "%{loadName} se puede usar cuando la carga de la batería es del %{lowerSoc}% o más.​",
    "batteryModeSoc": "Si la carga desciende por debajo del %{lowerSoc}%, %{loadName} no se puede usar hasta que la batería se recarga al %{upperSoc}%.",
    "loadControlHeading": "Controle la energía de sus cargas cuando no esté conectado a la red",
    "loadControlSubHeading": "Todas las cargas se encenderán cuando estén Conectadas a la red",
    "powered": "Alimentado",
    "notPowered": "No alimentado",
    "unknown": "Desconocido",
    "permissionOfIntstaller": "No tiene autorización para editar la configuración de este dispositivo. Comuníquese con su instalador o con el servicio de atención al cliente de Enphase para obtener más información al respecto.",
    "willbePowered": "Su %{loadName} siempre estará encendida en este estado.",
    "poweredOnOffGrid": "Su %{loadName} se alimentará según el funcionamiento seleccionado fuera de la red.",
    "continueModal": "¿Quiere continuar?",
    "infoDetails": " Cuando el control inteligente está desactivado o cuando su sistema está conectado a la red, las cargas siempre estarán alimentadas.",
    "newInfoDetails": "Controle la potencia de sus cargas en función del recurso energético o de la hora del día. También puede utilizar el modo Manual si quiere controlar la potencia de sus cargas de forma instantánea.",
    "enableSmartComtrol": "Asegúrese de que los interruptores de alimentación de estos dispositivos estén encendidos para utilizar esta función.",
    "enableToggle": "Activer Control inteligente?",
    "disableToggle": "Desactivar Control inteligente?",
    "apply": "Aplicar",
    "modalPara1": "<div>Cuando el control inteligente está <span style='color: #F37320'>habilitado</span>, puede elegir uno de los tres modos para el funcionamiento Fuera de la red.</div>",
    "disabledModalText": "La función de control inteligente está desactivada para esta carga. Habilite la función de control inteligente con el botón de alternancia para actualizar el comportamiento Fuera de la red",
    "batteryChargeLowerLimit": "El límite inferior de carga de batería no puede ser menor que 10 %",
    "batteryChargeHigherLimit": "El límite inferior de la Carga de la batería no puede ser superior al 90 %.",
    "loadControlLoadingToast": "La confirmación del estado de %{loadName} está tardando más de lo esperado. Vuelva a realizar la comprobación más tarde.",
    "loadControlTakingLonger": "La confirmación del estado de la carga está tardando más de lo esperado. Vuelva a realizar la comprobación más tarde.",
    "batteryChargeLowerHigherLimit": "El límite inferior y el límite superior de carga de la batería deben tener una diferencia mínima del 5 %.",
    "mode": "modo",
    "lcMainHeading": "Controle la potencia de sus cargas",
    "basic": "básico",
    "scheduled": "programado",
    "advanced": "avanzado",
    "manual": "Manual",
    "notSelected": "No seleccionado",
    "poweredWhen": "Encendido cuando la carga de la batería está por encima de",
    "poweredGenOn": "Alimentado cuando el generador está encendido",
    "poweredBetweenTime": "Encendido entre %{startTime} y %{endTime}",
    "onceDisconnected": "Una vez desconectada la carga de la fuente de alimentación, esta no se alimentará a menos que la batería se recargue al 100 %.",
    "alwaysPowered": "Siempre alimentado",
    "neverPowered": "Nunca alimentado",
    "minDiff": "La hora de inicio y la hora de finalización deben tener una diferencia mínima de 15 minutos.",
    "startLessThanEnd": "La Hora de inicio debe ser menor que la Hora de finalización",
    "notValidTime": "La Hora de inicio y la hora de Finalización deben estar dentro de %{startTime} y %{endTime}.",
    "completed": "Modo %{loadName} actualizado con éxito.",
    "notCompleted": "Su solicitud no pudo ser completada. Inténtelo de nuevo más tarde",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "No se ha encontrado el control de carga",
    "allowedWarning": "Cuando modifique esta ventana de tiempo, asegúrese de que su producción solar sea suficiente para dar soporte a su consumo durante toda esta ventana de tiempo.",
    "advancedMode": {
      "subtitle": "Controle la carga utilizando:",
      "notPowered": "Encendido cuando la carga está por encima de ",
      "batterySocDesc1": "No se alimenta cuando la carga cae por debajo de ",
      "batterySocDesc2": "Alimentado solo después de que la batería se recargue a ",
      "batterySocDesc3": " (incluso si el generador está encendido)",
      "notAvailable": "No disponible",
      "onGridGenPowered": "Alimentado",
      "offGridGenPowered": "Alimentado cuando el generador está encendido"
    }
  },
  "app_info": {
    "update_available": "Actualización de la aplicación disponible",
    "already_updatec": "Su aplicación está actualizada",
    "update_now": "Actualizar ahora",
    "latest_update": "Última actualización",
    "update_history": "Historial de actualizaciones",
    "show_more": "Mostrar más",
    "show_less": "Mostrar menos"
  },
  "s1": "Ayuda para seleccionar un perfil",
  "s2": "Sepa más sobre los perfiles de batería",
  "s3": "Sugerir un perfil para mí",
  "s4": "La carga de la baterías es mayor que la reserva",
  "s5": "Independencia energética después de las horas pico:",
  "s6": "Durante las horas no pico, sus paneles solares cargarán su batería primero antes de proveer energía a su hogar. El excedente de energía solar se devolverá a la red para reducir el importe de la factura de la luz.",
  "s7": "Si su hogar necesita más energía de la que producen los paneles solares, se utilizará electricidad proveniente de la red.",
  "s8": "Comportamiento del sistema durante las horas pico",
  "s9": "Reducir el importe de sus facturas de luz",
  "s10": "En algunas zonas, el costo de la electricidad fluctúa durante el día, siendo mayor en las horas pico, cuando hay una alta demanda de energía eléctrica.",
  "s11": "Para evitar el consumo de electricidad a un costo mayor, su hogar usará la batería. Si su hogar necesita más energía de la que puede suministrar la batería, se usará primero la energía solar y por último la red. El excedente de energía solar se exportará a la red.",
  "s12": "Durante la noche, cuando los paneles solares no están produciendo nada, su hogar usa la energía de la batería, a menos que se haya alcanzado el nivel de carga de reserva.",
  "s13": "La electricidad se importa desde la red cuando la energía solar no está disponible y su hogar necesita más energía de la que puede suministrar la batería.",
  "s14": "Suministrar energía limpia a su hogar",
  "s15": "Su hogar priorizará el uso de energía limpia. Durante el día, el sistema solar suministra energía al hogar y luego a la batería. El excedente se exporta a la red. Durante la noche, la batería suministra energía al hogar.",
  "s16": "Se importa electricidad desde la red cuando su hogar necesita más energía de la que el sistema solar y la batería pueden suministrar juntos.",
  "s17": "La batería se ha cargado por completo",
  "s18": "Comportamiento del sistema durante las horas no pico",
  "s19": "Los paneles suministrarán energía primero a la batería y luego al hogar. El excedente de energía se devolverá a la red.",
  "s20": "Durante la noche, o cada vez que necesite más energía de la que los paneles estén produciendo, su hogar utilizará electricidad de la red. La batería no se usa nunca, salvo durante un apagón.",
  "s21": "Toque un perfil para saltar a sus páginas.",
  "s22": "Deslice a la izquierda o a la derecha para leer más.",
  "s23": "Sus baterías se descargarán incluso después de las horas pico.",
  "s24": "La electricidad se importa desde la red cuando la energía solar no está disponible y su hogar necesita más energía de la que puede suministrar la batería.",
  "s25": "Comportamiento del sistema durante las horas no pico",
  "s26": "Seguir teniendo electricidad durante los apagones",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Esta es la cantidad estimada de ahorros monetarios de tu sistema basado en la producción solar. Se calcula a partir de los datos de la tasa de electricidad introducidos.",
      "noTeriffMsg": "Añade tarifa de luz para conocer tu ahorro",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Introducción",
      "billingCycle": {
        "more": "más que este último ciclo de facturación",
        "less": "menos que este el último ciclo de facturación",
        "same": "Casi igual que este último ciclo de facturación"
      },
      "calendarMonth": {
        "more": "más que el mes anterior",
        "less": "menos que el mes anterior",
        "same": "Más o menos lo mismo que el mes anterior"
      },
      "day": {
        "more": "más que a esta hora del día anterior",
        "less": "menos que a esta hora del día anterior",
        "same": "Más o menos lo mismo que el día anterior",
        "significantMore": "Significativamente más que el día anterior"
      },
      "week": {
        "more": "más que la semana anterior",
        "less": "menos que la semana anterior",
        "same": "Más o menos lo mismo que la semana anterior"
      },
      "year": {
        "more": "más que el año anterior",
        "less": "menos que el año anterior",
        "same": "Más o menos lo mismo que el año anterior"
      },
      "editElectricity": "EDITAR LA TASA DE ELECTRICIDAD",
      "viewSavingsBased": "Ver los ahorros en",
      "calendarMonthTitle": "Mes calendario",
      "calendarMonthDesc": "Rango de tiempo desde el primer hasta el último día del mes",
      "noExportRate": "Agregue %{exportCTA} para ver sus ahorros totales",
      "exportRate": "Tasa de exportación"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "No se puede conectar localmente",
    "limitedAppFunctionality": "Funcionalidad limitada de la aplicación",
    "needHelpGatewayWifi": "Necesita ayuda para configurar la conectividad Wi-Fi de la Puerta de enlace.",
    "howToConnectGatewayNetwork": "Cómo conectarse a la red de la Puerta de enlace",
    "connectGatewayToWifi": "Conectar el Puerta de enlace a la red Wi-Fi",
    "connectLocally": "CONÉCTESE LOCALMENTE",
    "checkNetworkConnection": "Compruebe su conexión de red.",
    "noInternetModalSubText1": "Compruebe su conexión de red. Mientras tanto, puede ver el estado actual del sistema.",
    "noInternetModalSubText2": "Compruebe su conexión de red. Mientras tanto, si está cerca de su sistema, puede conectarse localmente con la Puerta de enlace para ver el estado actual.",
    "refereshing": "Actualizando",
    "pullToReferesh": "Tirar para actualizar",
    "connectionStatus": "Su teléfono está ahora conectado localmente a la red de la Puerta de enlace.",
    "connectivityErrorMsg1": "Asegúrese de que tu teléfono y la Puerta de enlace estén en la misma red",
    "connectivityErrorMsg2": 'La Puerta de enlace se ha conectado recientemente a la red %{wifiName}.',
    "connectivityErrorMsg3": "Alternativamente, conecte su teléfono al Wi-Fi de la Puerta de enlace habilitando el modo AP en su Puerta de enlace",
    "connecting": "Su teléfono está intentando conectarse localmente con la Puerta de enlace para ver el estado actual.",
    "viewLiveStatus": "Ver el estado en directo",
    "pleaseTryAgainInSomeTime": "Inténtelo de nuevo en algún momento.",
    "connectedLocally": "Conectado localmente",
    "ssidNotMatchedError": "No ha conectado su teléfono móvil a la red correcta de la puerta de enlace. Conecte su teléfono móvil a esta red de puerta de enlace: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Redes de puerta de enlace para este sitio",
      "message": "Conecte su teléfono móvil solo a la red de una de las puertas de enlace de este sitio. A continuación, se muestran las redes de la puerta de enlace de este sitio:",
      "buttonText": "Bien, ¡entendido!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "No ha conectado su teléfono móvil a la red de la puerta de enlace correcta. Conecte su teléfono móvil solo a la red de una de las puertas de enlace de este sitio.",
    "configureButtonMultiEnvoyMsg": "No ha conectado su teléfono móvil a la red correcta de la puerta de enlace. Conecte su teléfono móvil solo a la red de una de las puertas de enlace de este sitio. A continuación, se muestran las redes de la puerta de enlace de este sitio:",
    "listOfGatewayNetworks": "Lista de redes de la puerta de enlace para este sitio",
    "configureWifiMultiEnvoyMsg": "Para configurar el Wi-Fi para la puerta de enlace (Nº de serie: XXXX) conecte su móvil al modo AP de esta puerta de enlace. Actualmente está conectado al modo AP de la puerta de enlace (Nº de serie:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "Cómo conectarse al Wi-Fi de la Puerta de enlace",
      "okGotIt": "Ok, entendido",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Conéctese a la red de la puerta de la puerta de enlace de manera local si desea cambiar los ajustes de su sistema.",
      "subText2": 'Asegúrese de que su teléfono y la Puerta de enlace estén en la misma red %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(La puerta de enlace se ha conectado recientemente a la red \"%{lastConnection}\")",
      "subText3": "Alternativamente, conecte su teléfono móvil al Wi-Fi de la Puerta de enlace activando el modo AP en su Puerta de enlace",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Conexiones Wi-Fi recientes de las Puertas de enlace",
      "gatewayPrefix": "N.S. de Puerta de enlace",
      "gatewayBtn": "Redes Wi-Fi de las puertas de enlace para este sitio",
      "alternetively": "Alternativamente, conecte su teléfono a cualquiera de las redes de las Puertas enlaces activando el modo AP en su Puerta de enlace."
    },
    "isTouPopupMsg": "El modo de ahorro no se puede activar, ya que solo funciona si tiene un Medidor de energía neta (NEM, Net Energy Metering) y su tarifa eléctrica varía según el tiempo de uso (ToU). El ajuste o la actualización de la tarifa eléctrica solo es posible cuando el teléfono está conectado a Internet.",
    "configWifiToGateway": "CONFIGURAR WI-FI PARA SU PUERTA DE ENLACE",
    "phoneNtConnectedToGateway": "Su teléfono no está conectado a la puerta de enlace",
    "chooseWifiNetwork": "Elija una red Wi-Fi que quiera utilizar con su puerta de enlace.",
    "learnWifiConfigToGatway": "Aprenda a configurar el Wi-Fi para su puerta de enlace",
    "step": "Paso",
    "connectPhoneToGateway": "Conecte su teléfono a la puerta de enlace",
    "connectToGatewayNetwork": "Conéctese a la red de la puerta de enlace para configurar el Wi-Fi de su puerta de enlace",
    "gatewayNtReachable": "No se puede acceder a su puerta de enlace",
    "pleaseEnsure": "Asegúrese:",
    "gatewayAPModeOn": "El modo AP de la puerta de enlace está activado",
    "phoneInCloseProximity": "El teléfono está cerca de la puerta de enlace",
    "mobileDataOff": "Los datos móviles (datos celulares) están desactivados",
    "searchingGateway": "Buscando la red de la puerta de enlace...",
    "devicePluggedIn": "Asegúrese de que su dispositivo esté cerca, enchufado y el modo AP esté activado",
    "connectingTo": "Conectando con",
    "reflectedInApp": "Esto puede tardar un par de minutos en reflejarse en la aplicaciónp",
    "connectionFailed": "No se ha podido conectar a la red de la puerta de enlacek",
    "connectedToGateway": "El teléfono está conectado a la puerta de enlace"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Conecte la puerta de enlace a la red Wi-Fi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Elija una red Wi-Fi a la que quiera conectar su puerta de enlace."), _defineProperty(_offline, "scanNetwork", "Escanee la red Wi-Fi"), _defineProperty(_offline, "enterPassword", "Introduzca la contraseña de"), _defineProperty(_offline, "join", "Únase a"), _defineProperty(_offline, "gatewayConnected", "La puerta de enlace está conectada a %{selectedWifi} con éxito"), _defineProperty(_offline, "disconnectPhoneFromGateway", "Ahora puede desconectar su teléfono de la red de la puerta de enlace y conectarlo a su Wi-Fi/activar sus datos móviles"), _defineProperty(_offline, "failedToConnect", "konnte nicht verbunden werden"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Asegúrese de que su puerta de enlace está conectada a una fuente de alimentación y de que se encuentra cerca de su puerta de enlace."), _defineProperty(_offline, "routerIsOn", "Asegúrese de que el router Wi-Fi esté encendido y de que se encuentre cerca del mismo."), _defineProperty(_offline, "unableToDisplayNetworks", "No se pueden mostrar las redes Wi-Fi"), _defineProperty(_offline, "errorDisplayingNetworks", "Se ha producido un error al mostrar las redes Wi-FI debido a algunos problemas técnicos. Inténtelo de nuevo."), _defineProperty(_offline, "errorInConnectingToWifi", "Se ha producido un error al conectarse a la red WiFi. Inténtelo más tarde o conéctese a otra red."), _defineProperty(_offline, "unableToConnect", "No se puede conectar"), _defineProperty(_offline, "pairGateway", "Empareje la puerta de enlace con su teléfono a través del bluetooth."), _offline),
  "tutorial": {
    "back": "Volver",
    "apMode": "Cómo activar el modo AP",
    "step1": "Paso 1 de 3",
    "step2": "Paso 2 de 3",
    "step3": "Paso 3 de 3",
    "powerOnGateway": "Encienda la puerta de enlace",
    "title2": "Pulse el botón de modo AP",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Comenzar",
    "next": "Paso siguiente",
    "prev": "Paso anterior",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "¡Listo!",
    "step1of2": "Paso 1 de 2",
    "step2of2": "Paso 2 de 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Intentemos conectar la puerta de enlace a su teléfono. Asegúrese de que esté cerca de la puerta de enlace y de que sus datos móviles estén apagados."
  }
};
module.exports = mobile;